'use strict';
window.ELEVENINE_PRODUCTS=[
  {
    "id": 1,
    "name": "Acelerador de repuesto ⚡eNINE",
    "slug": "acelerador-de-repuesto-enine",
    "category": "Accesorios",
    "group": "Accesorios",
    "price": 799,
    "stock": true,
    "year": 2023,
    "variants": {},
    "age": null,
    "image": "https://elevenine.com.mx/wp-content/uploads/2023/04/Bicicleta-Electrica-ENINE-Acelerador.jpg",
    "gallery": [
      "https://elevenine.com.mx/wp-content/uploads/2023/04/Bicicleta-Electrica-ENINE-Acelerador.jpg"
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2023/04/Bicicleta-Electrica-ENINE-Acelerador.jpg",
    "shortDescription": "El componente correcto para mantener tu equipo listo y seguir rodando.",
    "description": "Acelerador de repuesto ⚡eNINE pertenece a la línea de accesorios y refacciones ELEVENINE. Antes de comprar, verifica compatibilidad con tu modelo; nuestro equipo puede ayudarte por WhatsApp.",
    "benefits": [
      "Compatibilidad asistida",
      "Producto original o validado por ELEVENINE",
      "Compra protegida",
      "Soporte postventa",
      "Envíos nacionales"
    ],
    "specifications": {
      "SKU": "ELN9-001",
      "Categoría": "Accesorios",
      "Año de catálogo": "2023",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México",
      "Compatibilidad": "Confirmar con un asesor"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 2,
    "name": "BABY BIKE",
    "slug": "baby-bike",
    "category": "Bicicletas Infantiles",
    "group": "Bikes",
    "price": 1190,
    "stock": true,
    "year": 2022,
    "variants": {
      "Color": [
        "Amarillo",
        "Rosa"
      ]
    },
    "age": "baby",
    "image": "https://elevenine.com.mx/wp-content/uploads/2022/10/babybike-2.jpg",
    "gallery": [
      "https://elevenine.com.mx/wp-content/uploads/2022/10/babybike-2.jpg"
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2022/10/babybike-2.jpg",
    "shortDescription": "Diseñada para desarrollar confianza, control y diversión desde la primera rodada.",
    "description": "BABY BIKE combina una geometría cómoda con una experiencia de uso pensada para disfrutar cada recorrido. Selecciona las opciones disponibles y confirma con nuestro equipo la talla o configuración más adecuada.",
    "benefits": [
      "Manejo cómodo y progresivo",
      "Diseño pensado para uso recreativo",
      "Asesoría para elegir el modelo correcto",
      "Garantía ELEVENINE",
      "Entrega con seguimiento"
    ],
    "specifications": {
      "SKU": "ELN9-002",
      "Categoría": "Bicicletas Infantiles",
      "Año de catálogo": "2022",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 3,
    "name": "BABY BIKE EDICIÓN MOTO",
    "slug": "baby-bike-edicion-moto",
    "category": "Bicicletas Infantiles",
    "group": "Bikes",
    "price": [
      1190,
      1200
    ],
    "stock": true,
    "year": 2022,
    "variants": {
      "Edición": [
        "BMW",
        "HONDA",
        "KTM",
        "Rockstar",
        "YAMAHA",
        "SHERCO"
      ]
    },
    "age": "baby",
    "image": window.ELEVENINE_THEME_ASSET("asset:14caf35e37ae"),
    "gallery": [
      window.ELEVENINE_THEME_ASSET("asset:14caf35e37ae")
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2022/10/BABY-EDICION-MOTO.jpg",
    "shortDescription": "Diseñada para desarrollar confianza, control y diversión desde la primera rodada.",
    "description": "BABY BIKE EDICIÓN MOTO combina una geometría cómoda con una experiencia de uso pensada para disfrutar cada recorrido. Selecciona las opciones disponibles y confirma con nuestro equipo la talla o configuración más adecuada.",
    "benefits": [
      "Manejo cómodo y progresivo",
      "Diseño pensado para uso recreativo",
      "Asesoría para elegir el modelo correcto",
      "Garantía ELEVENINE",
      "Entrega con seguimiento"
    ],
    "specifications": {
      "SKU": "ELN9-003",
      "Categoría": "Bicicletas Infantiles",
      "Año de catálogo": "2022",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 4,
    "name": "Bandana OFF ROAD",
    "slug": "bandana-off-road",
    "category": "Accesorios",
    "group": "Accesorios",
    "price": 99,
    "stock": true,
    "year": 2024,
    "variants": {
      "Color": [
        "Morado",
        "Negro",
        "Azul",
        "Rosa"
      ]
    },
    "defaultSelections": {
      "Color": "Negro"
    },
    "age": null,
    "image": window.ELEVENINE_THEME_ASSET("asset:4a93c8c7ef71"),
    "gallery": [
      window.ELEVENINE_THEME_ASSET("asset:4a93c8c7ef71"),
      window.ELEVENINE_THEME_ASSET("asset:589f6967d741"),
      window.ELEVENINE_THEME_ASSET("asset:8d673d93b788"),
      window.ELEVENINE_THEME_ASSET("asset:e7610608f253")
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2024/07/BD6.jpg",
    "shortDescription": "El componente correcto para mantener tu equipo listo y seguir rodando.",
    "description": "Bandana OFF ROAD pertenece a la línea de accesorios y refacciones ELEVENINE. Antes de comprar, verifica compatibilidad con tu modelo; nuestro equipo puede ayudarte por WhatsApp.",
    "benefits": [
      "Compatibilidad asistida",
      "Producto original o validado por ELEVENINE",
      "Compra protegida",
      "Soporte postventa",
      "Envíos nacionales"
    ],
    "specifications": {
      "SKU": "ELN9-004",
      "Categoría": "Accesorios",
      "Año de catálogo": "2024",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México",
      "Compatibilidad": "Confirmar con un asesor"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 5,
    "name": "BATERÍA EXTRA",
    "slug": "bateria-extra",
    "category": "Accesorios",
    "group": "Accesorios",
    "price": 3500,
    "stock": true,
    "year": 2022,
    "variants": {},
    "age": null,
    "image": window.ELEVENINE_THEME_ASSET("asset:85206b0a1105"),
    "gallery": [
      window.ELEVENINE_THEME_ASSET("asset:85206b0a1105")
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2022/10/bateria.jpg",
    "shortDescription": "El componente correcto para mantener tu equipo listo y seguir rodando.",
    "description": "BATERÍA EXTRA pertenece a la línea de accesorios y refacciones ELEVENINE. Antes de comprar, verifica compatibilidad con tu modelo; nuestro equipo puede ayudarte por WhatsApp.",
    "benefits": [
      "Compatibilidad asistida",
      "Producto original o validado por ELEVENINE",
      "Compra protegida",
      "Soporte postventa",
      "Envíos nacionales"
    ],
    "specifications": {
      "SKU": "ELN9-005",
      "Categoría": "Accesorios",
      "Año de catálogo": "2022",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México",
      "Compatibilidad": "Confirmar con un asesor"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 6,
    "name": "Bicicleta de Montaña MTB 29″ DEEGAN",
    "hidden": true,
    "slug": "bicicleta-de-montana-mtb-29-deegan",
    "category": "Bicicletas MTB 29″",
    "group": "Bikes",
    "price": 5299,
    "stock": true,
    "year": 2022,
    "variants": {
      "Color": [
        "Gris",
        "Azul"
      ]
    },
    "age": "big",
    "image": window.ELEVENINE_THEME_ASSET("asset:0926912b3930"),
    "gallery": [
      window.ELEVENINE_THEME_ASSET("asset:0926912b3930")
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2022/10/Bicicleta-de-Montana-Deegan-1.jpg",
    "shortDescription": "Diseñada para desarrollar confianza, control y diversión desde la primera rodada.",
    "description": "Bicicleta de Montaña MTB 29″ DEEGAN combina una geometría cómoda con una experiencia de uso pensada para disfrutar cada recorrido. Selecciona las opciones disponibles y confirma con nuestro equipo la talla o configuración más adecuada.",
    "benefits": [
      "Manejo cómodo y progresivo",
      "Diseño pensado para uso recreativo",
      "Asesoría para elegir el modelo correcto",
      "Garantía ELEVENINE",
      "Entrega con seguimiento"
    ],
    "specifications": {
      "SKU": "ELN9-006",
      "Categoría": "Bicicletas MTB 29″",
      "Año de catálogo": "2022",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 7,
    "name": "Bicicleta Eléctrica ⚡eNINE Rodado 12″",
    "slug": "bicicleta-electrica-enine-rodado-12",
    "category": "Bicicletas Infantiles",
    "group": "Bikes",
    "price": 16300,
    "stock": true,
    "year": 2022,
    "variants": {},
    "age": "electric",
    "image": window.ELEVENINE_THEME_ASSET("asset:0cd72922418b"),
    "gallery": [
      window.ELEVENINE_THEME_ASSET("asset:0cd72922418b")
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2022/10/enine12-1.jpg",
    "shortDescription": "Diseñada para desarrollar confianza, control y diversión desde la primera rodada.",
    "description": "Bicicleta Eléctrica ⚡eNINE Rodado 12″ combina una geometría cómoda con una experiencia de uso pensada para disfrutar cada recorrido. Selecciona las opciones disponibles y confirma con nuestro equipo la talla o configuración más adecuada.",
    "benefits": [
      "Manejo cómodo y progresivo",
      "Diseño pensado para uso recreativo",
      "Asesoría para elegir el modelo correcto",
      "Garantía ELEVENINE",
      "Entrega con seguimiento"
    ],
    "specifications": {
      "SKU": "ELN9-007",
      "Categoría": "Bicicletas Infantiles",
      "Año de catálogo": "2022",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 8,
    "name": "Bicicleta Eléctrica ⚡eNINE Rodado 16″",
    "slug": "bicicleta-electrica-enine-rodado-16",
    "category": "Bicicletas Infantiles",
    "group": "Bikes",
    "price": 17500,
    "stock": false,
    "year": 2022,
    "variants": {},
    "age": "electric",
    "image": window.ELEVENINE_THEME_ASSET("asset:50cf1ab22a3e"),
    "gallery": [
      window.ELEVENINE_THEME_ASSET("asset:50cf1ab22a3e")
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2022/10/ENINE-16.jpg",
    "shortDescription": "Diseñada para desarrollar confianza, control y diversión desde la primera rodada.",
    "description": "Bicicleta Eléctrica ⚡eNINE Rodado 16″ combina una geometría cómoda con una experiencia de uso pensada para disfrutar cada recorrido. Selecciona las opciones disponibles y confirma con nuestro equipo la talla o configuración más adecuada.",
    "benefits": [
      "Manejo cómodo y progresivo",
      "Diseño pensado para uso recreativo",
      "Asesoría para elegir el modelo correcto",
      "Garantía ELEVENINE",
      "Entrega con seguimiento"
    ],
    "specifications": {
      "SKU": "ELN9-008",
      "Categoría": "Bicicletas Infantiles",
      "Año de catálogo": "2022",
      "Disponibilidad": "Inventario disponible",
      "Distribución": "ELEVENINE México"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 9,
    "name": "Bicicleta Eléctrica ⚡eNINE Rodado 20″",
    "slug": "bicicleta-electrica-enine-rodado-20",
    "category": "Bicicletas Infantiles",
    "group": "Bikes",
    "price": 19000,
    "stock": true,
    "year": 2024,
    "variants": {},
    "age": "electric",
    "image": window.ELEVENINE_THEME_ASSET("asset:2fecd7d0dd62"),
    "gallery": [
      window.ELEVENINE_THEME_ASSET("asset:2fecd7d0dd62")
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2024/03/enine20-1.jpg",
    "shortDescription": "Diseñada para desarrollar confianza, control y diversión desde la primera rodada.",
    "description": "Bicicleta Eléctrica ⚡eNINE Rodado 20″ combina una geometría cómoda con una experiencia de uso pensada para disfrutar cada recorrido. Selecciona las opciones disponibles y confirma con nuestro equipo la talla o configuración más adecuada.",
    "benefits": [
      "Manejo cómodo y progresivo",
      "Diseño pensado para uso recreativo",
      "Asesoría para elegir el modelo correcto",
      "Garantía ELEVENINE",
      "Entrega con seguimiento"
    ],
    "specifications": {
      "SKU": "ELN9-009",
      "Categoría": "Bicicletas Infantiles",
      "Año de catálogo": "2024",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 10,
    "name": "Cargador de Batería para ⚡eNINE",
    "slug": "cargador-de-bateria-para-enine",
    "category": "Accesorios",
    "group": "Accesorios",
    "price": 799,
    "stock": true,
    "year": 2023,
    "variants": {},
    "age": null,
    "image": "https://elevenine.com.mx/wp-content/uploads/2023/03/Bicicleta-Electrica-ENINE-Cargador-1-.jpg",
    "gallery": [
      "https://elevenine.com.mx/wp-content/uploads/2023/03/Bicicleta-Electrica-ENINE-Cargador-1-.jpg"
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2023/03/Bicicleta-Electrica-ENINE-Cargador-1-.jpg",
    "shortDescription": "El componente correcto para mantener tu equipo listo y seguir rodando.",
    "description": "Cargador de Batería para ⚡eNINE pertenece a la línea de accesorios y refacciones ELEVENINE. Antes de comprar, verifica compatibilidad con tu modelo; nuestro equipo puede ayudarte por WhatsApp.",
    "benefits": [
      "Compatibilidad asistida",
      "Producto original o validado por ELEVENINE",
      "Compra protegida",
      "Soporte postventa",
      "Envíos nacionales"
    ],
    "specifications": {
      "SKU": "ELN9-010",
      "Categoría": "Accesorios",
      "Año de catálogo": "2023",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México",
      "Compatibilidad": "Confirmar con un asesor"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 11,
    "name": "Carpas Toldos Personalizados",
    "slug": "carpas-toldos-personalizados",
    "category": "Carpas Profesionales",
    "group": "Carpas",
    "price": [
      16000,
      47000
    ],
    "stock": true,
    "year": 2024,
    "variants": {
      "Medida": [
        "3x3 NACIONAL",
        "3x3 PREMIUM IMPORTADO",
        "3x6 NACIONAL",
        "3X6 PREMIUM IMPORTADO",
        "4X8 PREMIUM IMPORTADO"
      ]
    },
    "age": null,
    "image": window.ELEVENINE_THEME_ASSET("asset:8e47a86c2fac"),
    "gallery": [
      window.ELEVENINE_THEME_ASSET("asset:8e47a86c2fac"),
      window.ELEVENINE_THEME_ASSET("asset:06c61cc212e6"),
      window.ELEVENINE_THEME_ASSET("asset:e91961f1fcdc"),
      window.ELEVENINE_THEME_ASSET("asset:1836400bfaee"),
      window.ELEVENINE_THEME_ASSET("asset:7d64f0049b91"),
      window.ELEVENINE_THEME_ASSET("asset:2d89105d6e63"),
      window.ELEVENINE_THEME_ASSET("asset:9bbad020a31f")
    ],
    "includeGalleryImagesWithVideo": true,
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2024/10/Carpas-1080-x-1080-px.jpg",
    "shortDescription": "Presencia profesional para paddock, eventos, exposiciones y puntos de venta.",
    "description": "Carpas y toldos personalizados en distintas medidas, con opciones nacionales y premium importadas. El precio mostrado corresponde al rango publicado y la cotización final depende de medida, impresión y requerimientos.",
    "benefits": [
      "Personalización con logotipo y colores",
      "Opciones nacionales y premium",
      "Uso en paddock, eventos y exposiciones",
      "Asesoría de configuración",
      "Envíos a todo México"
    ],
    "specifications": {
      "SKU": "ELN9-011",
      "Categoría": "Carpas Profesionales",
      "Año de catálogo": "2024",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México",
      "Personalización": "Disponible bajo cotización"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 12,
    "name": "CASCO ADULTO MTB",
    "slug": "casco-adulto-mtb",
    "category": "Cascos Adultos MTB",
    "group": "Protección",
    "price": 990,
    "stock": true,
    "year": 2022,
    "variants": {
      "Color": [
        "Blanco/Rojo"
      ]
    },
    "defaultSelections": {
      "Color": "Blanco/Rojo"
    },
    "age": null,
    "image": "https://elevenine.com.mx/wp-content/uploads/2022/10/casco-1.jpg",
    "gallery": [
      "https://elevenine.com.mx/wp-content/uploads/2022/10/casco-1.jpg"
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2022/10/casco-1.jpg",
    "shortDescription": "Protección, visión y control para rodar con seguridad sin perder el estilo racing.",
    "description": "CASCO ADULTO MTB está pensado para complementar tu equipo off-road o MTB. Elige la variante disponible y recibe atención directa para confirmar ajuste, compatibilidad y cuidados.",
    "benefits": [
      "Protección para uso deportivo",
      "Ajuste y selección asistida",
      "Diseño ELEVENINE",
      "Compra protegida",
      "Envíos nacionales"
    ],
    "specifications": {
      "SKU": "ELN9-012",
      "Categoría": "Cascos Adultos MTB",
      "Año de catálogo": "2022",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México",
      "Uso recomendado": "MTB y off-road"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 13,
    "name": "Casco Dropframe MTB",
    "slug": "casco-dropframe-mtb",
    "category": "Cascos Adultos MTB",
    "group": "Protección",
    "price": 1872,
    "stock": true,
    "year": 2023,
    "variants": {
      "Color": [
        "Gris",
        "Negro",
        "Rojo"
      ],
      "Talla": [
        "S",
        "M"
      ]
    },
    "age": null,
    "image": "https://elevenine.com.mx/wp-content/uploads/2023/07/Casco-Dropframe-2.jpg",
    "gallery": [
      "https://elevenine.com.mx/wp-content/uploads/2023/07/Casco-Dropframe-2.jpg"
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2023/07/Casco-Dropframe-2.jpg",
    "shortDescription": "Protección, visión y control para rodar con seguridad sin perder el estilo racing.",
    "description": "Casco Dropframe MTB está pensado para complementar tu equipo off-road o MTB. Elige la variante disponible y recibe atención directa para confirmar ajuste, compatibilidad y cuidados.",
    "benefits": [
      "Protección para uso deportivo",
      "Ajuste y selección asistida",
      "Diseño ELEVENINE",
      "Compra protegida",
      "Envíos nacionales"
    ],
    "specifications": {
      "SKU": "ELN9-013",
      "Categoría": "Cascos Adultos MTB",
      "Año de catálogo": "2023",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México",
      "Uso recomendado": "MTB y off-road"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 14,
    "name": "CASCO FULLFACE INFANTIL",
    "slug": "casco-fullface-infantil",
    "category": "Cascos Infantiles",
    "group": "Protección",
    "price": 1200,
    "stock": true,
    "year": 2022,
    "variants": {},
    "age": null,
    "image": window.ELEVENINE_THEME_ASSET("asset:42a998c6e1e0"),
    "gallery": [
      window.ELEVENINE_THEME_ASSET("asset:42a998c6e1e0"),
      window.ELEVENINE_THEME_ASSET("asset:db8aabdb96fb")
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2022/10/fullface-ngo2-1.jpg",
    "shortDescription": "Protección, visión y control para rodar con seguridad sin perder el estilo racing.",
    "description": "CASCO FULLFACE INFANTIL está pensado para complementar el equipo off-road o MTB de los peques. La galería incluye una demostración adicional de la mandíbula desmontable para apreciar mejor su funcionamiento y ajuste.",
    "benefits": [
      "Protección para uso deportivo",
      "Ajuste y selección asistida",
      "Diseño ELEVENINE",
      "Compra protegida",
      "Envíos nacionales"
    ],
    "specifications": {
      "SKU": "ELN9-014",
      "Categoría": "Cascos Infantiles",
      "Año de catálogo": "2022",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México",
      "Uso recomendado": "MTB y off-road",
      "Galería adicional": "Video de mandíbula desmontable"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE.",
    "galleryVideos": [
      {
        "src": window.ELEVENINE_THEME_ASSET("asset:d0ffb90cc5bd"),
        "poster": window.ELEVENINE_THEME_ASSET("asset:940ad5ed8915"),
        "label": "Mandíbula desmontable"
      }
    ]
  },
  {
    "id": 15,
    "name": "CASCO FULLFACE MTB ADULTO",
    "slug": "casco-fullface-mtb-adulto",
    "category": "Cascos Adultos MTB",
    "group": "Protección",
    "price": 2540,
    "stock": true,
    "year": 2023,
    "variants": {
      "Color": [
        "Negro",
        "Blanco/Rojo"
      ]
    },
    "defaultSelections": {
      "Color": "Negro"
    },
    "age": null,
    "image": window.ELEVENINE_THEME_ASSET("asset:0b852ea01ffe"),
    "gallery": [],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2023/12/casco-fullface-adulto.jpeg",
    "shortDescription": "Protección, visión y control para rodar con seguridad sin perder el estilo racing.",
    "description": "CASCO FULLFACE MTB ADULTO está pensado para complementar tu equipo off-road o MTB. Elige la variante disponible y recibe atención directa para confirmar ajuste, compatibilidad y cuidados.",
    "benefits": [
      "Protección para uso deportivo",
      "Ajuste y selección asistida",
      "Diseño ELEVENINE",
      "Compra protegida",
      "Envíos nacionales"
    ],
    "specifications": {
      "SKU": "ELN9-015",
      "Categoría": "Cascos Adultos MTB",
      "Año de catálogo": "2023",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México",
      "Uso recomendado": "MTB y off-road"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 16,
    "name": "Casco MTB MATCH",
    "slug": "casco-mtb-match",
    "category": "Cascos Adultos MTB",
    "group": "Protección",
    "price": 1490,
    "stock": true,
    "year": 2024,
    "variants": {
      "Color": [
        "Blanco",
        "Negro Brillante",
        "Negro",
        "Azul"
      ]
    },
    "age": null,
    "image": window.ELEVENINE_THEME_ASSET("asset:96b15923de4d"),
    "gallery": [
      window.ELEVENINE_THEME_ASSET("asset:96b15923de4d")
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2024/03/Casco-Match-Blanco-2.jpg",
    "shortDescription": "Protección, visión y control para rodar con seguridad sin perder el estilo racing.",
    "description": "Casco MTB MATCH está pensado para complementar tu equipo off-road o MTB. Elige la variante disponible y recibe atención directa para confirmar ajuste, compatibilidad y cuidados.",
    "benefits": [
      "Protección para uso deportivo",
      "Ajuste y selección asistida",
      "Diseño ELEVENINE",
      "Compra protegida",
      "Envíos nacionales"
    ],
    "specifications": {
      "SKU": "ELN9-016",
      "Categoría": "Cascos Adultos MTB",
      "Año de catálogo": "2024",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México",
      "Uso recomendado": "MTB y off-road"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 17,
    "name": "Control de Velocidad y Apagado ⚡eNINE",
    "slug": "control-de-velocidad-y-apagado-enine",
    "category": "Accesorios",
    "group": "Accesorios",
    "price": 799,
    "stock": true,
    "year": 2023,
    "variants": {},
    "age": null,
    "image": "https://elevenine.com.mx/wp-content/uploads/2023/04/Bicicleta-Electrica-ENINE-Control.jpg",
    "gallery": [
      "https://elevenine.com.mx/wp-content/uploads/2023/04/Bicicleta-Electrica-ENINE-Control.jpg"
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2023/04/Bicicleta-Electrica-ENINE-Control.jpg",
    "shortDescription": "El componente correcto para mantener tu equipo listo y seguir rodando.",
    "description": "Control de Velocidad y Apagado ⚡eNINE pertenece a la línea de accesorios y refacciones ELEVENINE. Antes de comprar, verifica compatibilidad con tu modelo; nuestro equipo puede ayudarte por WhatsApp.",
    "benefits": [
      "Compatibilidad asistida",
      "Producto original o validado por ELEVENINE",
      "Compra protegida",
      "Soporte postventa",
      "Envíos nacionales"
    ],
    "specifications": {
      "SKU": "ELN9-017",
      "Categoría": "Accesorios",
      "Año de catálogo": "2023",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México",
      "Compatibilidad": "Confirmar con un asesor"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 18,
    "name": "Controlador para ⚡eNINE 12″ o 16″",
    "slug": "controlador-para-enine-12-o-16",
    "category": "Accesorios",
    "group": "Accesorios",
    "price": 799,
    "stock": true,
    "year": 2023,
    "variants": {},
    "age": null,
    "image": "https://elevenine.com.mx/wp-content/uploads/2023/04/Bicicleta-Electrica-ENINE-Controlador.jpg",
    "gallery": [
      "https://elevenine.com.mx/wp-content/uploads/2023/04/Bicicleta-Electrica-ENINE-Controlador.jpg"
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2023/04/Bicicleta-Electrica-ENINE-Controlador.jpg",
    "shortDescription": "El componente correcto para mantener tu equipo listo y seguir rodando.",
    "description": "Controlador para ⚡eNINE 12″ o 16″ pertenece a la línea de accesorios y refacciones ELEVENINE. Antes de comprar, verifica compatibilidad con tu modelo; nuestro equipo puede ayudarte por WhatsApp.",
    "benefits": [
      "Compatibilidad asistida",
      "Producto original o validado por ELEVENINE",
      "Compra protegida",
      "Soporte postventa",
      "Envíos nacionales"
    ],
    "specifications": {
      "SKU": "ELN9-018",
      "Categoría": "Accesorios",
      "Año de catálogo": "2023",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México",
      "Compatibilidad": "Confirmar con un asesor"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 19,
    "name": "Goggles DELTA FORCE",
    "slug": "goggles-delta-force",
    "category": "Goggles",
    "group": "Protección",
    "price": [
      990,
      1150
    ],
    "stock": true,
    "year": 2024,
    "variants": {
      "Versión": [
        "Negro",
        "NEGRO PERSONALIZADO"
      ]
    },
    "age": null,
    "image": "https://elevenine.com.mx/wp-content/uploads/2024/02/DELTA-FORCE.jpg",
    "gallery": [
      "https://elevenine.com.mx/wp-content/uploads/2024/02/DELTA-FORCE.jpg"
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2024/02/DELTA-FORCE.jpg",
    "shortDescription": "Visión clara y estilo racing, con opción de personalizar la correa con nombre, número, apodo o nombre y número juntos.",
    "description": "Goggles DELTA FORCE puede pedirse en versión regular o personalizada. En la opción personalizada puedes agregar un nombre, un número, un apodo o combinar nombre y número, y previsualizarlo directamente sobre la correa antes de añadirlo al carrito.",
    "benefits": [
      "Personalización visible en tiempo real",
      "Nombre y número juntos",
      "Protección para uso deportivo",
      "Ajuste y selección asistida",
      "Envíos nacionales"
    ],
    "specifications": {
      "SKU": "ELN9-019",
      "Categoría": "Goggles",
      "Año de catálogo": "2024",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México",
      "Uso recomendado": "MTB y off-road",
      "Personalización": "Nombre, número, apodo o nombre + número"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE.",
    "customizableGoggles": true
  },
  {
    "id": 20,
    "name": "Goggles FORCE ONE",
    "slug": "goggles-force-one",
    "category": "Goggles",
    "group": "Protección",
    "price": [
      990,
      1150
    ],
    "stock": true,
    "year": 2025,
    "variants": {
      "Versión": [
        "Blanco",
        "Negro",
        "Rojo",
        "BLANCO PERSONALIZADO",
        "NEGRO PERSONALIZADO",
        "ROJO PERSONALIZADO"
      ]
    },
    "age": null,
    "image": window.ELEVENINE_THEME_ASSET("asset:5e02558648f4"),
    "gallery": [
      window.ELEVENINE_THEME_ASSET("asset:5e02558648f4")
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2025/02/F1.jpg",
    "shortDescription": "Visión clara y estilo racing, con opción de personalizar la correa con nombre, número, apodo o nombre y número juntos.",
    "description": "Goggles FORCE ONE puede pedirse en versión regular o personalizada. En la opción personalizada puedes agregar un nombre, un número, un apodo o combinar nombre y número, y previsualizarlo directamente sobre la correa antes de añadirlo al carrito.",
    "benefits": [
      "Personalización visible en tiempo real",
      "Nombre y número juntos",
      "Protección para uso deportivo",
      "Ajuste y selección asistida",
      "Envíos nacionales"
    ],
    "specifications": {
      "SKU": "ELN9-020",
      "Categoría": "Goggles",
      "Año de catálogo": "2025",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México",
      "Uso recomendado": "MTB y off-road",
      "Personalización": "Nombre, número, apodo o nombre + número"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE.",
    "customizableGoggles": true
  },
  {
    "id": 21,
    "name": "Guantes ELN9",
    "slug": "guantes-eln9",
    "category": "Guantes",
    "group": "Protección",
    "price": 450,
    "stock": true,
    "year": 2025,
    "variants": {
      "Talla": [
        "M",
        "L"
      ]
    },
    "age": null,
    "image": window.ELEVENINE_THEME_ASSET("asset:1e50ad996bbd"),
    "gallery": [
      window.ELEVENINE_THEME_ASSET("asset:1e50ad996bbd")
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2025/02/guante.jpg",
    "shortDescription": "Protección, visión y control para rodar con seguridad sin perder el estilo racing.",
    "description": "Guantes ELN9 está pensado para complementar tu equipo off-road o MTB. Elige la variante disponible y recibe atención directa para confirmar ajuste, compatibilidad y cuidados.",
    "benefits": [
      "Protección para uso deportivo",
      "Ajuste y selección asistida",
      "Diseño ELEVENINE",
      "Compra protegida",
      "Envíos nacionales"
    ],
    "specifications": {
      "SKU": "ELN9-021",
      "Categoría": "Guantes",
      "Año de catálogo": "2025",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México",
      "Uso recomendado": "MTB y off-road"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 22,
    "name": "HYPER BEE",
    "slug": "hyper-bee",
    "category": "SUR-RON",
    "group": "Motos",
    "price": 83000,
    "stock": true,
    "year": 2026,
    "variants": {
      "Modelo": [
        "2025",
        "2026"
      ],
      "Color": [
        "Amarillo",
        "Verde",
        "Azul",
        "Rosa"
      ]
    },
    "age": null,
    "image": window.ELEVENINE_THEME_ASSET("asset:3f2a466e0c6b"),
    "gallery": [
      window.ELEVENINE_THEME_ASSET("asset:3f2a466e0c6b")
    ],
    "remoteImage": window.ELEVENINE_THEME_ASSET("asset:3f2a466e0c6b"),
    "shortDescription": "Moto eléctrica infantil SUR-RON, ideal para niños de 7 a 10 años: compacta, configurable y con funciones de seguridad.",
    "description": "HYPER BEE es un modelo infantil SUR-RON, ideal para niños de 7 a 10 años. Está disponible en configuración 2025 y 2026. El modelo 2025 se ofrece en Amarillo, Verde, Azul y Rosa; el modelo 2026 en Verde, Azul y Amarillo. Conserva su enfoque para pilotos jóvenes con tres velocidades, reversa, paro magnético de emergencia y control remoto.",
    "benefits": [
      "Respuesta eléctrica inmediata",
      "Asesoría especializada antes de comprar",
      "Producto original con respaldo ELEVENINE",
      "Soporte postventa y acceso a refacciones",
      "Envíos a todo México"
    ],
    "specifications": {
      "SKU": "ELN9-022",
      "Categoría": "SUR-RON",
      "Edad recomendada": "Ideal 7–10 años",
      "Tipo de uso": "Infantil",
      "Año de catálogo": "2025–2026",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México",
      "Tren motriz": "100% eléctrico",
      "Rodado": "12″",
      "Aceleración": "0–50 km/h en 3.6 s",
      "Peso": "38 kg",
      "Autonomía": "Hasta 50 km",
      "Carga": "20–80% en 2.5 h",
      "Modelos disponibles": "2025 · 2026",
      "Colores 2025": "Amarillo · Verde · Azul · Rosa",
      "Colores 2026": "Verde · Azul · Amarillo"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE.",
    "variantDependencies": {
      "Color": {
        "dependsOn": "Modelo",
        "optionsByValue": {
          "2025": [
            "Amarillo",
            "Verde",
            "Azul",
            "Rosa"
          ],
          "2026": [
            "Verde",
            "Azul",
            "Amarillo"
          ]
        }
      }
    },
    "defaultSelections": {
      "Modelo": "2026",
      "Color": "Azul"
    },
    "modelDefaultSelections": {
      "2025": {
        "Color": "Rosa"
      },
      "2026": {
        "Color": "Azul"
      }
    },
    "modelYearDetails": {
      "2025": {
        "title": "HYPER BEE 2025",
        "summary": "Una máquina compacta, ágil y configurable para que los pilotos jóvenes desarrollen control y confianza en cada recorrido.",
        "highlights": [
          "Modelo infantil · ideal para niños de 7 a 10 años",
          "Colores 2025: Amarillo, Verde, Azul y Rosa",
          "Plataforma compacta para pilotos jóvenes",
          "Tres velocidades, reversa y funciones de seguridad"
        ]
      },
      "2026": {
        "title": "HYPER BEE 2026 · MAYOR DESEMPEÑO",
        "summary": "Actualizada para ofrecer una entrega de potencia más precisa, autonomía optimizada y una experiencia de manejo todavía más completa.",
        "highlights": [
          "Modelo infantil · ideal para niños de 7 a 10 años",
          "Colores 2026: Verde, Azul y Amarillo",
          "Sistema de potencia y batería actualizado",
          "Respuesta y autonomía optimizadas",
          "Kit de herramientas de cortesía, sujeto a disponibilidad"
        ],
        "note": "La configuración técnica final puede variar por lote. ELEVENINE confirma la ficha exacta antes de cerrar tu compra."
      }
    }
  },
  {
    "id": 23,
    "name": "Kit de Gráficos para ⚡eNINE",
    "slug": "kit-de-graficos-para-enine",
    "category": "Accesorios",
    "group": "Accesorios",
    "price": 849,
    "stock": true,
    "year": 2022,
    "variants": {},
    "age": null,
    "image": "https://elevenine.com.mx/wp-content/uploads/2022/10/graficos-ENINE.jpeg",
    "gallery": [
      "https://elevenine.com.mx/wp-content/uploads/2022/10/graficos-ENINE.jpeg"
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2022/10/graficos-ENINE.jpeg",
    "shortDescription": "El componente correcto para mantener tu equipo listo y seguir rodando.",
    "description": "Kit de Gráficos para ⚡eNINE pertenece a la línea de accesorios y refacciones ELEVENINE. Antes de comprar, verifica compatibilidad con tu modelo; nuestro equipo puede ayudarte por WhatsApp.",
    "benefits": [
      "Compatibilidad asistida",
      "Producto original o validado por ELEVENINE",
      "Compra protegida",
      "Soporte postventa",
      "Envíos nacionales"
    ],
    "specifications": {
      "SKU": "ELN9-023",
      "Categoría": "Accesorios",
      "Año de catálogo": "2022",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México",
      "Compatibilidad": "Confirmar con un asesor"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 24,
    "name": "Mica Repuesto Goggles FORCE ONE",
    "slug": "mica-repuesto-goggles-force-one",
    "category": "Goggles",
    "group": "Protección",
    "price": 150,
    "stock": true,
    "year": "Lanzamiento",
    "variants": {
      "Color": [
        "Blanco",
        "Negro",
        "Azul"
      ]
    },
    "age": null,
    "image": "https://elevenine.com.mx/wp-content/uploads/2026/04/MICA-CLRA.jpg",
    "gallery": [
      "https://elevenine.com.mx/wp-content/uploads/2026/04/MICA-CLRA.jpg"
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2026/04/MICA-CLRA.jpg",
    "shortDescription": "Protección, visión y control para rodar con seguridad sin perder el estilo racing.",
    "description": "Mica Repuesto Goggles FORCE ONE está pensado para complementar tu equipo off-road o MTB. Elige la variante disponible y recibe atención directa para confirmar ajuste, compatibilidad y cuidados.",
    "benefits": [
      "Protección para uso deportivo",
      "Ajuste y selección asistida",
      "Diseño ELEVENINE",
      "Compra protegida",
      "Envíos nacionales"
    ],
    "specifications": {
      "SKU": "ELN9-024",
      "Categoría": "Goggles",
      "Año de catálogo": "Nuevo lanzamiento",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México",
      "Uso recomendado": "MTB y off-road"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 25,
    "name": "MT20 Bicicleta Infantil",
    "slug": "mt20-bicicleta-infantil",
    "category": "Bicicletas Infantiles",
    "group": "Bikes",
    "price": 6300,
    "stock": true,
    "hidden": true,
    "year": 2025,
    "variants": {},
    "age": "big",
    "image": "https://elevenine.com.mx/wp-content/uploads/2025/01/MT20-2.jpg",
    "gallery": [
      "https://elevenine.com.mx/wp-content/uploads/2025/01/MT20-2.jpg"
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2025/01/MT20-2.jpg",
    "shortDescription": "Diseñada para desarrollar confianza, control y diversión desde la primera rodada.",
    "description": "MT20 Bicicleta Infantil combina una geometría cómoda con una experiencia de uso pensada para disfrutar cada recorrido. Selecciona las opciones disponibles y confirma con nuestro equipo la talla o configuración más adecuada.",
    "benefits": [
      "Manejo cómodo y progresivo",
      "Diseño pensado para uso recreativo",
      "Asesoría para elegir el modelo correcto",
      "Garantía ELEVENINE",
      "Entrega con seguimiento"
    ],
    "specifications": {
      "SKU": "ELN9-025",
      "Categoría": "Bicicletas Infantiles",
      "Año de catálogo": "2025",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 26,
    "name": "Sombrero Racing de Paja",
    "slug": "sombrero-racing-de-paja",
    "category": "Sombreros Racing",
    "group": "Accesorios",
    "price": [
      500,
      750
    ],
    "stock": true,
    "year": 2024,
    "variants": {
      "Diseño": [
        "KTM",
        "ELN9",
        "TLD"
      ]
    },
    "age": null,
    "image": window.ELEVENINE_THEME_ASSET("asset:623c744e9439"),
    "gallery": [
      window.ELEVENINE_THEME_ASSET("asset:623c744e9439")
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2024/06/ELEVENINE-HATS.jpg",
    "shortDescription": "El componente correcto para mantener tu equipo listo y seguir rodando.",
    "description": "Sombrero Racing de Paja pertenece a la línea de accesorios y refacciones ELEVENINE. Antes de comprar, verifica compatibilidad con tu modelo; nuestro equipo puede ayudarte por WhatsApp.",
    "benefits": [
      "Compatibilidad asistida",
      "Producto original o validado por ELEVENINE",
      "Compra protegida",
      "Soporte postventa",
      "Envíos nacionales"
    ],
    "specifications": {
      "SKU": "ELN9-026",
      "Categoría": "Sombreros Racing",
      "Año de catálogo": "2024",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 27,
    "name": "STARK VARG EX",
    "slug": "stark-varg-ex",
    "category": "STARK VARG",
    "group": "Motos",
    "price": 327000,
    "stock": true,
    "year": 2025,
    "variants": {
      "Color": [
        "Blanco",
        "Gris",
        "Rojo"
      ]
    },
    "age": null,
    "image": window.ELEVENINE_THEME_ASSET("asset:2b71241dc185"),
    "gallery": [
      window.ELEVENINE_THEME_ASSET("asset:2b71241dc185")
    ],
    "remoteImage": window.ELEVENINE_THEME_ASSET("asset:2b71241dc185"),
    "shortDescription": "Potencia eléctrica y respuesta inmediata para llevar cada recorrido a otro nivel.",
    "description": "STARK VARG EX forma parte de la selección eléctrica ELEVENINE para quienes buscan desempeño, control y una experiencia de manejo intensa. Nuestro equipo puede compartir la ficha técnica completa y ayudarte a elegir la configuración correcta.",
    "benefits": [
      "Respuesta eléctrica inmediata",
      "Asesoría especializada antes de comprar",
      "Producto original con respaldo ELEVENINE",
      "Soporte postventa y acceso a refacciones",
      "Envíos a todo México"
    ],
    "specifications": {
      "SKU": "ELN9-027",
      "Categoría": "STARK VARG",
      "Año de catálogo": "2025",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México",
      "Tren motriz": "100% eléctrico"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE.",
    "defaultSelections": {
      "Color": "Blanco"
    }
  },
  {
    "id": 28,
    "name": "STARK VARG MX1.2",
    "slug": "stark-varg-mx1-2",
    "category": "STARK VARG",
    "group": "Motos",
    "price": 307000,
    "stock": true,
    "year": 2025,
    "variants": {
      "Color": [
        "Blanco",
        "Gris",
        "Rojo"
      ]
    },
    "age": null,
    "image": window.ELEVENINE_THEME_ASSET("asset:a840d957e623"),
    "gallery": [
      window.ELEVENINE_THEME_ASSET("asset:a840d957e623")
    ],
    "remoteImage": window.ELEVENINE_THEME_ASSET("asset:a840d957e623"),
    "shortDescription": "Motocross eléctrica de alto rendimiento con respuesta inmediata y configuración precisa.",
    "description": "STARK VARG MX1.2 lleva la entrega de potencia eléctrica al circuito con una plataforma enfocada en competencia, control y ajuste. Disponible en Blanco, Gris y Rojo con respaldo y asesoría especializada de ELEVENINE México.",
    "benefits": [
      "Respuesta eléctrica inmediata",
      "Asesoría especializada antes de comprar",
      "Producto original con respaldo ELEVENINE",
      "Soporte postventa y acceso a refacciones",
      "Envíos a todo México"
    ],
    "specifications": {
      "SKU": "ELN9-028",
      "Categoría": "STARK VARG",
      "Año de catálogo": "2025",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México",
      "Tren motriz": "100% eléctrico",
      "Disciplina": "Motocross / Off-road",
      "Colores": "Blanco · Gris · Rojo"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE.",
    "defaultSelections": {
      "Color": "Gris"
    }
  },
  {
    "id": 29,
    "name": "STARK VARG SM",
    "slug": "stark-varg-sm",
    "category": "STARK VARG",
    "group": "Motos",
    "price": 327000,
    "stock": true,
    "year": 2025,
    "variants": {
      "Color": [
        "Blanco",
        "Gris",
        "Rojo"
      ]
    },
    "age": null,
    "image": window.ELEVENINE_THEME_ASSET("asset:57ccf820bbf2"),
    "gallery": [
      window.ELEVENINE_THEME_ASSET("asset:57ccf820bbf2")
    ],
    "remoteImage": window.ELEVENINE_THEME_ASSET("asset:57ccf820bbf2"),
    "shortDescription": "Potencia eléctrica y respuesta inmediata para llevar cada recorrido a otro nivel.",
    "description": "STARK VARG SM forma parte de la selección eléctrica ELEVENINE para quienes buscan desempeño, control y una experiencia de manejo intensa. Nuestro equipo puede compartir la ficha técnica completa y ayudarte a elegir la configuración correcta.",
    "benefits": [
      "Respuesta eléctrica inmediata",
      "Asesoría especializada antes de comprar",
      "Producto original con respaldo ELEVENINE",
      "Soporte postventa y acceso a refacciones",
      "Envíos a todo México"
    ],
    "specifications": {
      "SKU": "ELN9-029",
      "Categoría": "STARK VARG",
      "Año de catálogo": "2025",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México",
      "Tren motriz": "100% eléctrico"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE.",
    "defaultSelections": {
      "Color": "Rojo"
    }
  },
  {
    "id": 30,
    "name": "STRIDER Balance Edición Moto",
    "slug": "strider-balance-edicion-moto",
    "category": "Bicicletas Infantiles",
    "group": "Bikes",
    "price": 2099,
    "stock": true,
    "year": 2022,
    "variants": {
      "Edición": [
        "BMW",
        "HONDA",
        "KTM",
        "Rockstar",
        "YAMAHA",
        "SHERCO"
      ]
    },
    "age": "balance",
    "image": "https://elevenine.com.mx/wp-content/uploads/2022/10/balance-edicion-moto.jpg",
    "gallery": [
      "https://elevenine.com.mx/wp-content/uploads/2022/10/balance-edicion-moto.jpg"
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2022/10/balance-edicion-moto.jpg",
    "shortDescription": "Diseñada para desarrollar confianza, control y diversión desde la primera rodada.",
    "description": "STRIDER Balance Edición Moto combina una geometría cómoda con una experiencia de uso pensada para disfrutar cada recorrido. Selecciona las opciones disponibles y confirma con nuestro equipo la talla o configuración más adecuada.",
    "benefits": [
      "Manejo cómodo y progresivo",
      "Diseño pensado para uso recreativo",
      "Asesoría para elegir el modelo correcto",
      "Garantía ELEVENINE",
      "Entrega con seguimiento"
    ],
    "specifications": {
      "SKU": "ELN9-030",
      "Categoría": "Bicicletas Infantiles",
      "Año de catálogo": "2022",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 31,
    "name": "STRIDER Bicicleta de Balance",
    "slug": "strider-bicicleta-de-balance",
    "category": "Bicicletas Infantiles",
    "group": "Bikes",
    "price": 2099,
    "stock": true,
    "year": 2022,
    "variants": {
      "Color": [
        "Azul",
        "Negro",
        "Rojo",
        "Rosa"
      ]
    },
    "age": "balance",
    "image": window.ELEVENINE_THEME_ASSET("asset:fb8a3a85731f"),
    "gallery": [
      window.ELEVENINE_THEME_ASSET("asset:fb8a3a85731f")
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2022/10/balance-10.jpg",
    "shortDescription": "Diseñada para desarrollar confianza, control y diversión desde la primera rodada.",
    "description": "STRIDER Bicicleta de Balance combina una geometría cómoda con una experiencia de uso pensada para disfrutar cada recorrido. Selecciona las opciones disponibles y confirma con nuestro equipo la talla o configuración más adecuada.",
    "benefits": [
      "Manejo cómodo y progresivo",
      "Diseño pensado para uso recreativo",
      "Asesoría para elegir el modelo correcto",
      "Garantía ELEVENINE",
      "Entrega con seguimiento"
    ],
    "specifications": {
      "SKU": "ELN9-031",
      "Categoría": "Bicicletas Infantiles",
      "Año de catálogo": "2022",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE."
  },
  {
    "id": 32,
    "name": "SUR-RON LIGHT BEE X",
    "slug": "sur-ron-light-bee-x",
    "category": "SUR-RON",
    "group": "Motos",
    "price": 119900,
    "stock": true,
    "year": 2026,
    "variants": {
      "Modelo": [
        "2025",
        "2026"
      ],
      "Color": [
        "Negro",
        "Verde",
        "Azul",
        "Morado",
        "Blanco"
      ]
    },
    "age": null,
    "image": window.ELEVENINE_THEME_ASSET("asset:1c3c9909cba9"),
    "gallery": [
      window.ELEVENINE_THEME_ASSET("asset:1c3c9909cba9")
    ],
    "remoteImage": window.ELEVENINE_THEME_ASSET("asset:1c3c9909cba9"),
    "shortDescription": "Ligera, ágil y eléctrica: una plataforma off-road con aceleración inmediata.",
    "description": "SUR-RON LIGHT BEE X puede configurarse como modelo 2025 o 2026. La versión 2025 está disponible en Negro, Verde, Azul y Morado; la versión 2026 en Blanco, Negro, Verde y Morado. Mantiene una plataforma ligera y ágil con respuesta eléctrica inmediata.",
    "benefits": [
      "Respuesta eléctrica inmediata",
      "Asesoría especializada antes de comprar",
      "Producto original con respaldo ELEVENINE",
      "Soporte postventa y acceso a refacciones",
      "Envíos a todo México"
    ],
    "specifications": {
      "SKU": "ELN9-032",
      "Categoría": "SUR-RON",
      "Año de catálogo": "2026",
      "Disponibilidad": "En existencia",
      "Distribución": "ELEVENINE México",
      "Tren motriz": "100% eléctrico",
      "Potencia": "Hasta 8000 W",
      "Aceleración": "0–50 km/h en 2.7 s",
      "Velocidad máxima": "75 km/h",
      "Autonomía": "Hasta 80 km",
      "Peso": "57 kg",
      "Carga": "20–80% en 2 h",
      "Modelos disponibles": "2025 · 2026",
      "Colores 2025": "Negro · Verde · Azul · Morado",
      "Colores 2026": "Blanco · Negro · Verde · Morado (preventa)"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE.",
    "variantDependencies": {
      "Color": {
        "dependsOn": "Modelo",
        "optionsByValue": {
          "2025": [
            "Negro",
            "Verde",
            "Azul",
            "Morado"
          ],
          "2026": [
            "Blanco",
            "Negro",
            "Verde",
            "Morado"
          ]
        }
      }
    },
    "defaultSelections": {
      "Modelo": "2026"
    },
    "modelYearDetails": {
      "2025": {
        "title": "LIGHT BEE X 2025",
        "summary": "Ligera, ágil y explosiva: una plataforma eléctrica off-road creada para disfrutar aceleración inmediata y control en cualquier terreno.",
        "highlights": [
          "Colores 2025: Negro, Verde, Azul y Morado",
          "Sistema eléctrico de 60 V / 40 Ah",
          "Potencia máxima de hasta 8 kW"
        ]
      },
      "2026": {
        "title": "LIGHT BEE X 2026 · NUEVA POTENCIA",
        "summary": "Una configuración eléctrica actualizada para entregar más potencia, mejor gestión de energía y una respuesta contundente desde el primer giro.",
        "highlights": [
          "Colores 2026: Blanco, Negro, Verde y Morado",
          "Sistema eléctrico actualizado a 72 V / 35 Ah",
          "Potencia máxima de hasta 10 kW",
          "Gestión de energía y respuesta mejoradas"
        ],
        "note": "Negro y Blanco cuentan con inventario disponible. Verde y Morado se pueden ordenar en preventa con apartado de $50,000 MXN. La ficha técnica y el equipamiento exactos se confirman con ELEVENINE de acuerdo con el lote disponible."
      }
    }
  },
  {
    "id": 33,
    "name": "SUR-RON ULTRA BEE",
    "slug": "sur-ron-ultra-bee",
    "category": "SUR-RON",
    "group": "Motos",
    "price": 166000,
    "stock": false,
    "year": 2026,
    "variants": {
      "Color": [
        "Café",
        "Negro"
      ]
    },
    "age": null,
    "image": "https://elevenine.com.mx/wp-content/uploads/2025/10/ULTRA-2026-NGO.jpg",
    "gallery": [
      "https://elevenine.com.mx/wp-content/uploads/2025/10/ULTRA-2026-NGO.jpg"
    ],
    "remoteImage": "https://elevenine.com.mx/wp-content/uploads/2025/10/ULTRA-2026-NGO.jpg",
    "shortDescription": "Potencia eléctrica y respuesta inmediata para llevar cada recorrido a otro nivel.",
    "description": "SUR-RON ULTRA BEE 2026 ofrece una plataforma eléctrica de alto desempeño para senderos exigentes. Está disponible en Café y Negro; la disponibilidad final se confirma directamente con el equipo ELEVENINE.",
    "benefits": [
      "Respuesta eléctrica inmediata",
      "Asesoría especializada antes de comprar",
      "Producto original con respaldo ELEVENINE",
      "Soporte postventa y acceso a refacciones",
      "Envíos a todo México"
    ],
    "specifications": {
      "SKU": "ELN9-033",
      "Categoría": "SUR-RON",
      "Año de catálogo": "2026",
      "Disponibilidad": "Agotado",
      "Distribución": "ELEVENINE México",
      "Tren motriz": "100% eléctrico",
      "Colores": "Café · Negro"
    },
    "shipping": "Envíos disponibles a todo México. El tiempo y la modalidad se confirman al procesar el pedido.",
    "warranty": "Garantía ELEVENINE aplicable según el tipo de producto y sus condiciones de uso. Conserva tu comprobante de compra.",
    "care": "Revisa el producto antes de cada uso y sigue las recomendaciones del fabricante. Para refacciones o mantenimiento, contacta a ELEVENINE.",
    "modelYearDetails": {
      "2026": {
        "title": "ULTRA BEE 2026",
        "summary": "Configuración 2026 disponible en Café y Negro, con inventario activo para entrega y una plataforma eléctrica orientada a senderos exigentes.",
        "highlights": [
          "Color Negro con inventario disponible",
          "Color Café con inventario disponible",
          "Entrega de potencia inmediata"
        ]
      }
    }
  },
  {
    "id": 34,
    "name": "SUR-RON LIGHT BEE 2",
    "slug": "sur-ron-light-bee-2",
    "category": "SUR-RON",
    "group": "Motos",
    "price": null,
    "stock": false,
    "launch": true,
    "year": "Lanzamiento",
    "variants": {
      "Color": [
        "Blanco",
        "Negro",
        "Verde",
        "Café"
      ]
    },
    "defaultSelections": {
      "Color": "Blanco"
    },
    "age": null,
    "image": window.ELEVENINE_THEME_ASSET("asset:0cce66bb2d56"),
    "gallery": [
      window.ELEVENINE_THEME_ASSET("asset:0cce66bb2d56")
    ],
    "remoteImage": window.ELEVENINE_THEME_ASSET("asset:0cce66bb2d56"),
    "shortDescription": "Nuevo lanzamiento SUR-RON en colores Negro, Verde, Blanco y Café.",
    "description": "SUR-RON LIGHT BEE 2 ya puede apartarse en preventa con $50,000 MXN. Está disponible en Negro, Verde, Blanco y Café; la ficha técnica final se confirma directamente con el equipo ELEVENINE.",
    "benefits": [
      "Nuevo lanzamiento SUR-RON",
      "Disponible en cuatro colores",
      "Asesoría especializada",
      "Respaldo ELEVENINE México",
      "Información por WhatsApp"
    ],
    "specifications": {
      "SKU": "ELN9-034",
      "Categoría": "SUR-RON",
      "Año de catálogo": "Nuevo lanzamiento",
      "Disponibilidad": "PREVENTA · Aparta con $50,000 MXN",
      "Distribución": "ELEVENINE México",
      "Tren motriz": "100% eléctrico",
      "Colores": "Negro · Verde · Blanco · Café"
    },
    "shipping": "Disponible en diciembre. La fecha exacta de entrega y la modalidad de envío se confirman con un asesor ELEVENINE.",
    "warranty": "La garantía se informará junto con la ficha técnica y las condiciones finales de lanzamiento.",
    "care": "Consulta la ficha técnica definitiva y las recomendaciones de uso antes de confirmar tu configuración.",
    "modelYearDetails": {
      "Lanzamiento": {
        "title": "LIGHT BEE 2 · NUEVO LANZAMIENTO",
        "summary": "La nueva generación ligera de SUR-RON llega con una plataforma de mayor desempeño y cuatro opciones de color.",
        "highlights": [
          "Colores: Negro, Verde, Blanco y Café",
          "Batería con capacidad de 3.53 kWh",
          "Velocidad máxima anunciada de hasta 90 km/h",
          "Aceleración anunciada de 0–50 km/h en 1.8 s"
        ],
        "note": "Modelo en preventa. Aparta con $50,000 MXN y confirma con ELEVENINE la configuración, tiempos y saldo restante."
      }
    }
  }
];

(function(){
  const allProducts=window.ELEVENINE_PRODUCTS;
  const products=allProducts.filter(product=>!product.hidden);
  const byId=id=>products.find(p=>p.id===Number(id));
  const bySlug=slug=>products.find(p=>p.slug===slug);
  const money=n=>n==null?'PRECIO POR CONFIRMAR':new Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN',minimumFractionDigits:2}).format(Number(n))+' MXN';
  const basePrice=p=>p.price==null?0:(Array.isArray(p.price)?Number(p.price[0]):Number(p.price));
  const priceLabel=p=>p.price==null?'PRECIO POR CONFIRMAR':(Array.isArray(p.price)?money(p.price[0])+' – '+money(p.price[1]):money(p.price));
  const escapeHTML=value=>String(value??'').replace(/[&<>'"]/g,ch=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[ch]));
  const productUrl=p=>'/products/'+encodeURIComponent(p.slug);
  window.ELEVENINE_CATALOG={products,allProducts,byId,bySlug,money,basePrice,priceLabel,escapeHTML,productUrl};
})();


'use strict';

(() => {
  const category='Accesorios SUR-RON';
  const asset='assets/products/surron-accessories/';
  const brochure=window.ELEVENINE_THEME_ASSET("asset:c5e2dfd0351f");
  const common={
    category,
    group:category,
    price:null,
    stock:true,
    year:2026,
    age:null,
    quoteOnly:true,
    brochure,
    shipping:'Envíos disponibles a todo México. La disponibilidad y el tiempo de entrega se confirman con un asesor ELEVENINE.',
    warranty:'La garantía y compatibilidad se confirman con un asesor antes de cerrar la cotización.',
    care:'La instalación debe realizarse siguiendo las indicaciones del fabricante. Verifica tornillería, ajuste y compatibilidad antes de cada uso.'
  };
  const gallery=(image,start)=>[
    asset+image,
    `${asset}brochure/page-${String(start).padStart(2,'0')}.jpg`,
    `${asset}brochure/page-${String(start+1).padStart(2,'0')}.jpg`
  ];
  const make=(data)=>({
    ...common,
    ...data,
    image:asset+data.image,
    gallery:gallery(data.image,data.page),
    benefits:data.benefits||[
      'Diseño enfocado en rendimiento',
      'Compatibilidad indicada en el brochure',
      'Construcción de alta resistencia',
      'Asesoría especializada ELEVENINE',
      'Cotización directa por WhatsApp'
    ],
    specifications:{
      'SKU':`ELN9-SRA-${String(data.id-34).padStart(3,'0')}`,
      'Categoría':category,
      'Disponibilidad':'Consultar con un asesor',
      'Precio':'Por confirmar',
      ...data.specifications
    }
  });

  const products=[
    make({
      id:35,
      name:'Rear Shock Upgrade Spring',
      slug:'surron-rear-shock-upgrade-spring',
      image:'rear-shock-upgrade-spring.jpg',
      page:1,
      variants:{
        'Spring Rate':['550 LBS','600 LBS','650 LBS'],
        'Color':['Black','Blue','Red','Gold / White','Silver','Orange']
      },
      shortDescription:'More stability · Better control · Stronger support.',
      description:'Upgrade spring developed to improve rear suspension support and stability. Multiple spring rates allow the setup to be matched to rider weight and riding style while maintaining predictable shock response.',
      specifications:{
        'Spring Rate':'550 / 600 / 650 LBS',
        'Free Length':'110 mm',
        'Inner Diameter':'38 mm',
        'Outer Diameter':'54 mm',
        'Wire Diameter':'8 mm',
        'Weight':'Approx. 450 g',
        'Colors':'Black · Blue · Red · Gold/White · Silver · Orange'
      },
      benefits:['More stability','Better control','Stronger support','Multiple spring rates','Direct setup assistance']
    }),
    make({
      id:36,
      name:'Foot Pegs · Ultra Bee',
      slug:'surron-foot-pegs-ultra-bee',
      image:'foot-pegs-ultra-bee.jpg',
      page:3,
      variants:{'Color':['Black','Blue','Red','Gold','Silver','Orange']},
      shortDescription:'Strong grip · Wider support · CNC precision.',
      description:'Wide CNC-machined foot pegs designed for the SUR-RON Ultra Bee. The serrated platform provides stronger boot engagement and more stable support during standing or aggressive off-road riding.',
      specifications:{
        'Material':'7075 aluminum alloy',
        'Size':'120 × 32 mm',
        'Finish':'Anodized',
        'Surface':'Serrated anti-slip platform',
        'Weight':'288 g',
        'Compatibility':'SUR-RON Ultra Bee',
        'Colors':'Black · Blue · Red · Gold · Silver · Orange'
      },
      benefits:['Strong grip','Wider support','CNC precision','Direct-fit Ultra Bee','Anodized finish']
    }),
    make({
      id:37,
      name:'Front Disc Guard · Ultra Bee',
      slug:'surron-front-disc-guard-ultra-bee',
      image:'front-disc-guard-ultra-bee.jpg',
      page:5,
      variants:{'Color':['Black','Blue','Red','Gold','Silver','Orange']},
      shortDescription:'Rotor protection · Heavy-duty shield · Off-road ready.',
      description:'Front brake rotor guard for the SUR-RON Ultra Bee. Its machined protective arm and shield help reduce direct impacts from rocks, branches and trail debris without compromising access to the braking system.',
      specifications:{
        'Material':'6061-T6 aluminum alloy',
        'Construction':'Machined protective arm and shield',
        'Weight':'222 g',
        'Compatibility':'SUR-RON Ultra Bee',
        'Colors':'Black · Blue · Red · Gold · Silver · Orange'
      },
      benefits:['Rotor protection','Heavy-duty shield','Off-road ready','CNC-machined body','Direct-fit Ultra Bee']
    }),
    make({
      id:38,
      name:'Adjustable Brake Lever Set · Ultra Bee',
      slug:'surron-adjustable-brake-lever-set-ultra-bee',
      image:'adjustable-brake-lever-set-ultra-bee.jpg',
      page:7,
      variants:{'Color':['Blue','Red','Gold','Silver','Orange','Black']},
      shortDescription:'Folding protection · Better control · CNC precision.',
      description:'Adjustable brake lever set for the SUR-RON Ultra Bee. The folding blade helps absorb impacts, the spring-return mechanism restores its position, and the reach adjuster supports a more precise hand setup.',
      specifications:{
        'Material':'6061-T6 aluminum alloy',
        'Lever Blade Length':'99 mm',
        'Mechanism':'Folding blade with spring return',
        'Adjustment':'Reach adjuster',
        'Weight':'117 g',
        'Compatibility':'SUR-RON Ultra Bee',
        'Colors':'Blue · Red · Gold · Silver · Orange · Black'
      },
      benefits:['Folding protection','Better control','CNC precision','Adjustable reach','Direct-fit Ultra Bee']
    }),
    make({
      id:39,
      name:'Reinforced Shock Triangle Bracket',
      slug:'surron-reinforced-shock-triangle-bracket',
      image:'reinforced-shock-triangle-bracket.jpg',
      page:9,
      variants:{'Color':['Black','Blue','Red','Gold','Purple','Green']},
      shortDescription:'High rigidity · CNC precision · Strong support.',
      description:'Reinforced shock triangle bracket engineered for the SUR-RON Light Bee. The 22 mm CNC-machined structure increases rigidity around the suspension linkage and provides stronger support for demanding off-road use.',
      specifications:{
        'Material':'6061-T6 aluminum alloy',
        'Thickness':'22 mm',
        'Weight':'438 g',
        'Compatibility':'SUR-RON Light Bee',
        'Colors':'Black · Blue · Red · Gold · Purple · Green'
      },
      benefits:['High rigidity','CNC precision','Strong support','Reinforced suspension area','Direct-fit Light Bee']
    }),
    make({
      id:40,
      name:'Shock Linkage Bracket',
      slug:'surron-shock-linkage-bracket',
      image:'shock-linkage-bracket.jpg',
      page:11,
      variants:{'Color':['Black','Blue','Red','Gold','Purple','Green','Silver','Orange']},
      shortDescription:'Reinforced design · Smoother travel · Stable response.',
      description:'One-piece rear shock linkage bracket for the SUR-RON Light Bee. The reinforced CNC-machined structure and integrated oil seal are designed for smooth suspension movement and a stable response under load.',
      specifications:{
        'Material':'6061-T6 aluminum alloy',
        'Construction':'One-piece CNC linkage',
        'Protection':'Integrated oil seal',
        'Weight':'229 g',
        'Compatibility':'SUR-RON Light Bee',
        'Colors':'Black · Blue · Red · Gold · Purple · Green · Silver · Orange'
      },
      benefits:['Reinforced design','Smoother travel','Stable response','Integrated oil seal','Direct-fit Light Bee']
    }),
    make({
      id:41,
      name:'Caliper Bracket A-Type',
      slug:'surron-caliper-bracket-a-type',
      image:'caliper-bracket-a-type.jpg',
      page:13,
      variants:{'Color':['Black','Blue','Red','Gold','Silver','Orange']},
      shortDescription:'Stronger support · Greater protection · Dual caliper mounting codes.',
      description:'A-Type caliper bracket for the SUR-RON Light Bee. It supports direct-fit caliper installation and can be configured for original or oversized brake rotors to achieve a precise, reinforced mounting position.',
      specifications:{
        'Material':'6061-T6 aluminum alloy',
        'Mounting':'Direct-fit caliper support',
        'Rotor Support':'Original and oversized rotors',
        'Weight':'214 g',
        'Compatibility':'SUR-RON Light Bee',
        'Colors':'Black · Blue · Red · Gold · Silver · Orange'
      },
      benefits:['Stronger support','Greater protection','Dual mounting codes','Original or oversized rotors','Direct-fit Light Bee']
    }),
    make({
      id:42,
      name:'Front Fork Anchor',
      slug:'surron-front-fork-anchor',
      image:'front-fork-anchor.jpg',
      page:15,
      variants:{
        'Spacer Size':['3 mm','5 mm','15 mm','20 mm'],
        'Color':['Black','Red','Gold','Purple','Silver','Orange']
      },
      shortDescription:'Higher rigidity · Better alignment · Strong support.',
      description:'CNC-machined front fork anchor for the SUR-RON Light Bee. Available spacer sizes allow precise alignment while the aluminum construction reinforces the fork assembly and provides consistent support.',
      specifications:{
        'Material':'6061-T6 aluminum alloy',
        'Spacer Sizes':'3 / 5 / 15 / 20 mm',
        'Weight':'186 g',
        'Compatibility':'SUR-RON Light Bee',
        'Colors':'Black · Red · Gold · Purple · Silver · Orange'
      },
      benefits:['Higher rigidity','Better alignment','Strong support','Multiple spacer sizes','Direct-fit Light Bee']
    }),
    make({
      id:43,
      name:'Handlebar Riser',
      slug:'surron-handlebar-riser',
      image:'handlebar-riser.jpg',
      page:17,
      variants:{'Color':['Black','Blue','Red','Orange','Green']},
      shortDescription:'Better posture · Higher control · Strong support.',
      description:'Handlebar riser for the SUR-RON Light Bee, machined from 6061-T6 aluminum. Its 50 mm rise helps create a more upright riding position and improves control for taller riders or standing off-road use.',
      specifications:{
        'Material':'6061-T6 aluminum alloy',
        'Handlebar Diameter':'31.8 mm',
        'Rise Height':'50 mm',
        'Weight':'223 g',
        'Compatibility':'SUR-RON Light Bee',
        'Colors':'Black · Blue · Red · Orange · Green'
      },
      benefits:['Better posture','Higher control','Strong support','50 mm rise','Direct-fit Light Bee']
    }),
    make({
      id:44,
      name:'Front Floating Brake Rotor',
      slug:'surron-front-floating-brake-rotor',
      image:'front-floating-brake-rotor.jpg',
      page:19,
      variants:{'Color':['Silver']},
      shortDescription:'Stronger braking · Better cooling · Improved control.',
      description:'250 mm floating front brake rotor for the SUR-RON Light Bee. The two-piece 7075 aluminum and 20CR13 stainless-steel construction improves heat management and provides a stronger, more consistent braking response.',
      specifications:{
        'Material':'7075 aluminum + 20CR13 (SUS420) stainless steel',
        'Diameter':'250 mm',
        'Thickness':'2.0 mm',
        'Construction':'Floating rotor',
        'Weight':'470 g',
        'Color':'Silver',
        'Compatibility':'SUR-RON Light Bee'
      },
      benefits:['Stronger braking','Better cooling','Improved control','250 mm floating design','Direct-fit Light Bee']
    }),
    make({
      id:45,
      name:'Rotor Adapter Set · Front / Rear',
      slug:'surron-rotor-adapter-set-front-rear',
      image:'rotor-adapter-set.jpg',
      page:21,
      variants:{'Position':['Front','Rear'],'Color':['Black']},
      shortDescription:'Bigger rotor · Stronger braking · Precise fit.',
      description:'Front and rear rotor adapter set for the SUR-RON Light Bee. CNC-machined spacing positions the caliper correctly for larger brake rotors and preserves precise mounting geometry.',
      specifications:{
        'Material':'6061-T6 aluminum alloy',
        'Position':'Front / Rear caliper spacing',
        'Mounting':'Direct fit',
        'Front Weight':'47 g',
        'Rear Weight':'122 g',
        'Color':'Black',
        'Compatibility':'SUR-RON Light Bee'
      },
      benefits:['Bigger rotor support','Stronger braking','Precise fit','Front and rear options','Direct-fit Light Bee']
    }),
    make({
      id:46,
      name:'Folding Brake Lever · Light Bee / Talaria',
      slug:'surron-folding-brake-lever-light-bee-talaria',
      image:'folding-brake-lever.jpg',
      page:23,
      variants:{'Color':['Black','Blue','Red','Gold','Purple','Silver','Orange']},
      shortDescription:'Anti-impact · Smooth action · CNC precision.',
      description:'Folding brake lever designed for the SUR-RON Light Bee and Talaria. Its impact-resistant folding tip helps protect the lever in a fall while preserving smooth actuation and a precise hand feel.',
      specifications:{
        'Material':'6061-T6 aluminum alloy',
        'Lever Length':'99 mm',
        'Mechanism':'Folding tip',
        'Weight':'57 g',
        'Compatibility':'SUR-RON Light Bee · Talaria',
        'Colors':'Black · Blue · Red · Gold · Purple · Silver · Orange'
      },
      benefits:['Anti-impact design','Smooth action','CNC precision','Folding tip','Light Bee and Talaria compatibility']
    }),
    make({
      id:47,
      name:'Rear Sprocket · Light Bee',
      slug:'surron-rear-sprocket-light-bee',
      image:'rear-sprocket-light-bee.jpg',
      page:25,
      variants:{
        'Teeth':['52T','54T','58T'],
        'Color':['Black','Blue','Red','Gold','Purple','Silver','Orange','Titanium']
      },
      shortDescription:'Strong drive · Precise fit · Gear choices.',
      description:'CNC-machined rear sprocket for the SUR-RON Light Bee. Three tooth-count options allow the final drive to be tuned for acceleration or speed while retaining a precise chain and hub fit.',
      specifications:{
        'Material':'7075 aluminum alloy',
        'Options':'52T / 54T / 58T',
        'Chain Pitch':'108 / 110 / 112',
        'Thickness':'6.0 mm',
        'Weight':'52T: 240 g · 54T: 290 g · 58T: 240 g',
        'Compatibility':'SUR-RON Light Bee',
        'Colors':'Black · Blue · Red · Gold · Purple · Silver · Orange · Titanium'
      },
      benefits:['Strong drive','Precise fit','Three gear choices','7075 aluminum','Direct-fit Light Bee']
    }),
    make({
      id:48,
      name:'Skid Plate · Light Bee',
      slug:'surron-skid-plate-light-bee',
      image:'skid-plate-light-bee.jpg',
      page:27,
      variants:{'Color':['Silver']},
      shortDescription:'Full protection · Strong shield · Off-road ready.',
      description:'Heavy-duty skid plate for the SUR-RON Light Bee. The 3 mm aluminum shield protects the lower frame and powertrain area from rocks, impacts and trail debris.',
      specifications:{
        'Material':'5053 aluminum',
        'Thickness':'3 mm',
        'Weight':'670 g',
        'Color':'Silver',
        'Compatibility':'SUR-RON Light Bee'
      },
      benefits:['Full protection','Strong shield','Off-road ready','3 mm aluminum','Direct-fit Light Bee']
    }),
    make({
      id:49,
      name:'Extended Rear Fender · Light Bee',
      slug:'surron-extended-rear-fender-light-bee',
      image:'extended-rear-fender-light-bee.jpg',
      page:29,
      variants:{'Color':['Black','Blue','Red','Gold','Purple','Orange']},
      shortDescription:'Better coverage · Mud protection · Trail ready.',
      description:'Extended rear fender for the SUR-RON Light Bee. The additional 130 mm of coverage helps reduce mud and water spray while its painted PP construction is designed for changing weather and trail conditions.',
      specifications:{
        'Material':'PP plastic',
        'Extension':'130 mm',
        'Finish':'Painted and weather resistant',
        'Weight':'80 g',
        'Compatibility':'SUR-RON Light Bee',
        'Colors':'Black · Blue · Red · Gold · Purple · Orange'
      },
      benefits:['Better coverage','Mud protection','Trail ready','130 mm extension','Direct-fit Light Bee']
    }),
    make({
      id:50,
      name:'Foot Pegs · Light Bee',
      slug:'surron-foot-pegs-light-bee',
      image:'foot-pegs-light-bee.jpg',
      page:31,
      variants:{'Color':['Black','Blue','Red','Gold','Green','Silver','Orange']},
      shortDescription:'Strong grip · Wider support · CNC precision.',
      description:'Wide CNC-machined foot pegs for the SUR-RON Light Bee. The enlarged serrated platform improves boot grip and supports a stable riding stance on technical terrain.',
      specifications:{
        'Material':'6061-T6 aluminum alloy',
        'Size':'119 × 57 mm',
        'Weight':'265 g',
        'Compatibility':'SUR-RON Light Bee',
        'Colors':'Black · Blue · Red · Gold · Green · Silver · Orange'
      },
      benefits:['Strong grip','Wider support','CNC precision','Serrated platform','Direct-fit Light Bee']
    }),
    make({
      id:51,
      name:'Front Disc Guard · Light Bee',
      slug:'surron-front-disc-guard-light-bee',
      image:'front-disc-guard-light-bee.jpg',
      page:33,
      variants:{'Color':['Black','Blue','Red','Gold','Purple','Silver','Orange']},
      shortDescription:'Rotor protection · Strong shield · Off-road ready.',
      description:'Front brake rotor guard for the SUR-RON Light Bee. The CNC-machined aluminum structure adds a strong protective shield against trail impacts and debris.',
      specifications:{
        'Material':'6061-T6 aluminum alloy',
        'Weight':'205 g',
        'Compatibility':'SUR-RON Light Bee',
        'Colors':'Black · Blue · Red · Gold · Purple · Silver · Orange'
      },
      benefits:['Rotor protection','Strong shield','Off-road ready','CNC-machined aluminum','Direct-fit Light Bee']
    }),
    make({
      id:52,
      name:'Brake Pads',
      slug:'surron-brake-pads',
      image:'brake-pads.jpg',
      page:35,
      variants:{},
      shortDescription:'Strong bite · Better heat control · Longer life.',
      description:'Copper-based sintered brake pads for the SUR-RON Light Bee. The compound is formulated for a strong initial bite, improved heat management and reliable service life in demanding riding conditions.',
      specifications:{
        'Material':'Copper-based sintered compound',
        'Weight':'44 g',
        'Color':'N/A',
        'Compatibility':'SUR-RON Light Bee'
      },
      benefits:['Strong bite','Better heat control','Longer life','Sintered compound','Direct-fit Light Bee']
    }),
    make({
      id:53,
      name:'Seat Riser',
      slug:'surron-seat-riser',
      image:'seat-riser.jpg',
      page:37,
      variants:{'Color':['Black','Blue','Red','Gold','Purple','Green','Silver']},
      shortDescription:'Better posture · More clearance · Improved control.',
      description:'Seat riser kit for the SUR-RON Light Bee. It raises the seat by 2.5 inches and moves it forward by 1.5 inches to provide more clearance, a revised riding posture and improved control.',
      specifications:{
        'Material':'6061-T6 aluminum alloy',
        'Seat Rise':'2.5 in / 63.5 mm',
        'Forward Offset':'1.5 in / 38.1 mm',
        'Weight':'880 g',
        'Compatibility':'SUR-RON Light Bee',
        'Colors':'Black · Blue · Red · Gold · Purple · Green · Silver'
      },
      benefits:['Better posture','More clearance','Improved control','2.5-inch rise','Direct-fit Light Bee']
    }),
    make({
      id:54,
      name:'Adjustable Kickstand',
      slug:'surron-adjustable-kickstand',
      image:'adjustable-kickstand.jpg',
      page:39,
      variants:{'Color':['Black','Blue','Red','Gold','Silver']},
      shortDescription:'Adjustable height · Strong support · Wider stability.',
      description:'Adjustable kickstand for the SUR-RON Light Bee and Talaria. Its CNC-machined aluminum body offers up to 30 mm of height adjustment and a wider support platform for stable parking on varied surfaces.',
      specifications:{
        'Material':'6061-T6 aluminum alloy',
        'Height Adjustment':'Up to 30 mm',
        'Weight':'268 g',
        'Compatibility':'SUR-RON Light Bee · Talaria',
        'Colors':'Black · Blue · Red · Gold · Silver'
      },
      benefits:['Adjustable height','Strong support','Wider stability','30 mm adjustment','Light Bee and Talaria compatibility']
    })
  ];

  window.ELEVENINE_PRODUCTS.push(...products);

  const allProducts=window.ELEVENINE_PRODUCTS;
  const visibleProducts=allProducts.filter(product=>!product.hidden);
  const byId=id=>visibleProducts.find(product=>product.id===Number(id));
  const bySlug=slug=>visibleProducts.find(product=>product.slug===slug);
  const money=value=>value==null
    ?'PRECIO POR CONFIRMAR'
    :new Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN',minimumFractionDigits:2}).format(Number(value))+' MXN';
  const basePrice=product=>product.price==null?0:(Array.isArray(product.price)?Number(product.price[0]):Number(product.price));
  const priceLabel=product=>product.price==null
    ?'PRECIO POR CONFIRMAR'
    :(Array.isArray(product.price)?money(product.price[0])+' – '+money(product.price[1]):money(product.price));
  const escapeHTML=value=>String(value??'').replace(/[&<>'"]/g,character=>({
    '&':'&amp;',
    '<':'&lt;',
    '>':'&gt;',
    "'":'&#039;',
    '"':'&quot;'
  }[character]));
  const productUrl=product=>'/products/'+encodeURIComponent(product.slug);
  window.ELEVENINE_CATALOG={
    products:visibleProducts,
    allProducts,
    byId,
    bySlug,
    money,
    basePrice,
    priceLabel,
    escapeHTML,
    productUrl
  };
})();


'use strict';

(() => {
  const products=window.ELEVENINE_PRODUCTS||[];
  const byId=id=>products.find(product=>Number(product.id)===Number(id));
  const base='assets/products/surron-accessories/catalog-v2/';
  const media=(slug,file)=>window.ELEVENINE_THEME_ASSET(`${base}${slug}/${file}`);
  const fileName=value=>String(value).toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
    .replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
  const colorImages=(slug,colors)=>Object.fromEntries(
    colors.map(color=>[color,media(slug,`${fileName(color)}.webp`)])
  );
  const gallery=(slug,primary,count=4)=>[
    media(slug,primary),
    ...Array.from({length:count},(_,index)=>media(slug,`detalle-${String(index+1).padStart(2,'0')}.webp`))
  ];
  const records=[
    [35,'Resorte de mejora para amortiguador trasero','surron-rear-shock-upgrade-spring','negro.webp',
      {Resistencia:['550 LBS','600 LBS','650 LBS'],Color:['Negro','Rojo','Blanco','Azul','Dorado']},
      'Configura el soporte de la suspensión según el peso del piloto y el tipo de manejo.',
      'Resorte de mejora para la suspensión trasera de SUR-RON Light Bee. Sus tres rangos de carga permiten ajustar el soporte, reducir hundimientos y conservar una respuesta más predecible en uso off-road.',
      ['Soporte configurable','Mayor estabilidad','Respuesta uniforme','Tres rangos de carga','Asesoría de compatibilidad']],
    [36,'Estriberas CNC para Ultra Bee','surron-foot-pegs-ultra-bee','negro.webp',
      {Color:['Negro','Azul','Dorado','Naranja','Rojo','Plata']},
      'Plataforma amplia y dentada para mejorar el apoyo y el agarre de las botas.',
      'Estriberas mecanizadas en CNC para SUR-RON Ultra Bee. La plataforma ensanchada distribuye mejor el apoyo y el borde dentado ayuda a conservar el control al conducir de pie.',
      ['Agarre firme','Apoyo más amplio','Mecanizado CNC','Acabado anodizado','Diseño para Ultra Bee']],
    [37,'Protector de disco delantero para Ultra Bee','surron-front-disc-guard-ultra-bee','negro.webp',
      {Color:['Negro','Azul','Dorado','Naranja','Rojo','Plata']},
      'Protección mecanizada para reducir impactos directos sobre el disco delantero.',
      'Protector de disco delantero para SUR-RON Ultra Bee. Su estructura de aluminio ayuda a proteger el rotor de piedras, ramas y residuos sin bloquear el acceso al sistema de freno.',
      ['Protección del rotor','Aluminio mecanizado','Preparado para off-road','Montaje específico','Varios acabados']],
    [38,'Juego de manijas de freno ajustables para Ultra Bee','surron-adjustable-brake-lever-set-ultra-bee','negro.webp',
      {Color:['Negro','Azul','Dorado','Naranja','Rojo','Plata']},
      'Alcance ajustable y diseño abatible para una sensación de frenado más precisa.',
      'Juego de manijas ajustables para SUR-RON Ultra Bee. El mecanismo abatible ayuda a absorber golpes y el ajuste de alcance permite adaptar la posición a la mano del piloto.',
      ['Alcance ajustable','Protección abatible','Retorno por resorte','Mecanizado CNC','Diseño para Ultra Bee']],
    [39,'Soporte triangular reforzado de amortiguador','surron-reinforced-shock-triangle-bracket','negro.webp',
      {Color:['Negro','Azul','Dorado','Verde','Morado','Rojo']},
      'Refuerzo de alta rigidez para el conjunto de bieletas de la suspensión.',
      'Soporte triangular reforzado para SUR-RON Light Bee. Su cuerpo mecanizado de 22 mm aumenta la rigidez alrededor del sistema de suspensión en recorridos exigentes.',
      ['Mayor rigidez','Soporte reforzado','Precisión CNC','Acabado anodizado','Diseño para Light Bee']],
    [40,'Bieleta reforzada de suspensión','surron-shock-linkage-bracket','negro.webp',
      {Color:['Negro','Azul','Dorado','Verde','Naranja','Morado','Rojo','Plata']},
      'Bieleta de una sola pieza para un recorrido estable y una respuesta más uniforme.',
      'Bieleta trasera reforzada para SUR-RON Light Bee. Su construcción CNC de una pieza y el sello integrado favorecen un movimiento suave bajo carga.',
      ['Diseño reforzado','Recorrido más suave','Respuesta estable','Sello integrado','Diseño para Light Bee']],
    [41,'Soporte de cáliper tipo A','surron-caliper-bracket-a-type','negro.webp',
      {Color:['Negro','Azul','Dorado','Rojo','Plata']},
      'Soporte preciso para montar el cáliper con discos originales o de mayor diámetro.',
      'Soporte tipo A para el cáliper de SUR-RON Light Bee. Permite una posición reforzada y precisa al trabajar con el disco original o con configuraciones de mayor diámetro.',
      ['Montaje preciso','Soporte reforzado','Compatible con disco mayor','Aluminio CNC','Diseño para Light Bee']],
    [42,'Anclaje delantero de horquilla','surron-front-fork-anchor','negro.webp',
      {Separador:['3 mm','5 mm','15 mm','20 mm'],Color:['Negro','Azul','Dorado','Naranja','Morado','Rojo','Plata']},
      'Refuerza la alineación del conjunto delantero con cuatro medidas de separador.',
      'Anclaje de horquilla mecanizado para SUR-RON Light Bee. Las distintas medidas de separador facilitan una alineación precisa y un soporte consistente del conjunto delantero.',
      ['Alineación precisa','Mayor rigidez','Cuatro separadores','Aluminio CNC','Diseño para Light Bee'],2],
    [43,'Elevador de manubrio','surron-handlebar-riser','negro.webp',
      {Color:['Negro','Azul','Verde','Naranja','Rojo']},
      'Eleva el manubrio 50 mm para una postura más cómoda y mayor control de pie.',
      'Elevador de manubrio para SUR-RON Light Bee. Su aumento de 50 mm favorece una postura más erguida, especialmente para pilotos altos o conducción off-road de pie.',
      ['Mejor postura','Mayor control','Elevación de 50 mm','Aluminio CNC','Diseño para Light Bee']],
    [44,'Disco de freno delantero flotante','surron-front-floating-brake-rotor','principal.webp',{},
      'Rotor flotante de 250 mm para mejorar disipación de calor y consistencia de frenado.',
      'Disco delantero flotante de 250 mm para SUR-RON Light Bee. Su construcción de dos piezas combina aluminio 7075 y acero inoxidable para una respuesta firme y estable.',
      ['Frenado consistente','Mejor disipación','Diseño flotante','Diámetro de 250 mm','Diseño para Light Bee']],
    [45,'Adaptador de disco delantero o trasero','surron-rotor-adapter-set-front-rear','delantero.webp',
      {Posición:['Delantero','Trasero']},
      'Alinea el cáliper para instalar rotores de mayor diámetro en la posición elegida.',
      'Adaptador mecanizado para el freno delantero o trasero de SUR-RON Light Bee. Mantiene la geometría correcta del cáliper cuando se utiliza un rotor de mayor diámetro.',
      ['Ajuste preciso','Opción delantera o trasera','Soporte para rotor mayor','Aluminio CNC','Diseño para Light Bee']],
    [46,'Manija de freno abatible para Light Bee / Talaria','surron-folding-brake-lever-light-bee-talaria','negro.webp',
      {Color:['Negro','Azul','Dorado','Naranja','Morado','Rojo','Plata']},
      'Punta abatible para reducir daños por impacto y conservar un accionamiento preciso.',
      'Manija abatible compatible con SUR-RON Light Bee y Talaria. Su punta plegable ayuda a proteger la pieza durante una caída y mantiene una sensación de frenado controlada.',
      ['Protección contra impactos','Acción suave','Punta abatible','Aluminio CNC','Light Bee y Talaria']],
    [47,'Corona trasera para Light Bee','surron-rear-sprocket-light-bee','52t-negro.webp',
      {Dientes:['52T','54T','58T'],Color:['Negro','Azul','Dorado','Verde','Morado','Rojo','Titanio','Naranja']},
      'Tres relaciones disponibles para priorizar aceleración o velocidad final.',
      'Corona trasera CNC para SUR-RON Light Bee. Las opciones de 52, 54 y 58 dientes permiten ajustar la relación final manteniendo un acople preciso con la cadena y el cubo.',
      ['Relación configurable','Ajuste preciso','Tres medidas','Aluminio 7075','Diseño para Light Bee']],
    [48,'Protector inferior para Light Bee','surron-skid-plate-light-bee','plata.webp',
      {Color:['Plata']},
      'Placa de aluminio de 3 mm para proteger bastidor y tren motriz en uso off-road.',
      'Protector inferior de alta resistencia para SUR-RON Light Bee. La placa de aluminio cubre la parte baja del bastidor y ayuda a reducir impactos de piedras y obstáculos.',
      ['Protección inferior','Aluminio de 3 mm','Cobertura amplia','Preparado para off-road','Diseño para Light Bee']],
    [49,'Salpicadera trasera extendida para Light Bee','surron-extended-rear-fender-light-bee','negro.webp',
      {Color:['Negro','Azul','Dorado','Naranja','Morado','Rojo']},
      '130 mm adicionales de cobertura para reducir salpicaduras de lodo y agua.',
      'Salpicadera trasera extendida para SUR-RON Light Bee. Su longitud adicional mejora la cobertura en lluvia, lodo y terrenos variables.',
      ['Mayor cobertura','Protección contra lodo','Extensión de 130 mm','Material resistente','Diseño para Light Bee']],
    [50,'Estriberas CNC para Light Bee','surron-foot-pegs-light-bee','negro.webp',
      {Color:['Negro','Azul','Dorado','Verde','Naranja','Rojo','Plata']},
      'Plataforma amplia y dentada para una posición de manejo más estable.',
      'Estriberas CNC para SUR-RON Light Bee. La superficie ensanchada y dentada mejora el apoyo de la bota en terreno técnico.',
      ['Agarre firme','Apoyo más amplio','Superficie dentada','Aluminio CNC','Diseño para Light Bee']],
    [51,'Protector de disco delantero para Light Bee','surron-front-disc-guard-light-bee','negro.webp',
      {Color:['Negro','Azul','Dorado','Naranja','Morado','Rojo','Plata']},
      'Escudo mecanizado para proteger el rotor delantero de piedras y residuos.',
      'Protector de rotor delantero para SUR-RON Light Bee. Su estructura de aluminio CNC ayuda a reducir daños por impactos durante la conducción off-road.',
      ['Protección del rotor','Escudo resistente','Aluminio CNC','Preparado para off-road','Diseño para Light Bee']],
    [52,'Pastillas de freno sinterizadas','surron-brake-pads','principal.webp',{},
      'Compuesto sinterizado para una mordida firme y mejor manejo de temperatura.',
      'Pastillas de freno sinterizadas con base de cobre para SUR-RON Light Bee. Están pensadas para ofrecer respuesta inicial firme, control térmico y vida útil confiable.',
      ['Mordida firme','Control térmico','Compuesto sinterizado','Vida útil confiable','Diseño para Light Bee']],
    [53,'Elevador de asiento para Light Bee','surron-seat-riser','negro.webp',
      {Color:['Negro','Azul','Dorado','Verde','Morado','Rojo','Plata']},
      'Eleva el asiento 2.5 pulgadas y lo adelanta 1.5 para mejorar espacio y postura.',
      'Kit elevador de asiento para SUR-RON Light Bee. Modifica la posición del piloto para ofrecer mayor espacio, una postura más natural y mejor control.',
      ['Más espacio','Postura mejorada','Elevación de 2.5 in','Desplazamiento de 1.5 in','Diseño para Light Bee']],
    [54,'Pata lateral ajustable','surron-adjustable-kickstand','negro.webp',
      {Color:['Negro','Azul','Dorado','Rojo','Plata']},
      'Hasta 30 mm de ajuste y una base más amplia para estacionar con estabilidad.',
      'Pata lateral ajustable para SUR-RON Light Bee y Talaria. El cuerpo CNC permite adaptar la altura y la plataforma ampliada mejora el apoyo en superficies variadas.',
      ['Altura ajustable','Base más amplia','Hasta 30 mm','Aluminio CNC','Light Bee y Talaria']]
  ];
  const compatibility={
    35:'SUR-RON Light Bee',36:'SUR-RON Ultra Bee',37:'SUR-RON Ultra Bee',38:'SUR-RON Ultra Bee',
    39:'SUR-RON Light Bee',40:'SUR-RON Light Bee',41:'SUR-RON Light Bee',42:'SUR-RON Light Bee',
    43:'SUR-RON Light Bee',44:'SUR-RON Light Bee',45:'SUR-RON Light Bee',
    46:'SUR-RON Light Bee y Talaria',47:'SUR-RON Light Bee',48:'SUR-RON Light Bee',
    49:'SUR-RON Light Bee',50:'SUR-RON Light Bee',51:'SUR-RON Light Bee',52:'SUR-RON Light Bee',
    53:'SUR-RON Light Bee',54:'SUR-RON Light Bee y Talaria'
  };
  const specLabels={
    'Spring Rate':'Resistencia','Free Length':'Longitud libre','Inner Diameter':'Diámetro interior',
    'Outer Diameter':'Diámetro exterior','Wire Diameter':'Diámetro del alambre',Weight:'Peso',
    Colors:'Colores',Color:'Color',Size:'Medidas',Finish:'Acabado',Surface:'Superficie',
    Compatibility:'Compatibilidad',Construction:'Construcción','Lever Blade Length':'Longitud de la manija',
    Mechanism:'Mecanismo',Adjustment:'Ajuste',Thickness:'Espesor',Protection:'Protección',
    Mounting:'Montaje','Rotor Support':'Compatibilidad del rotor','Spacer Sizes':'Medidas de separador',
    'Handlebar Diameter':'Diámetro del manubrio','Rise Height':'Elevación',Diameter:'Diámetro',
    Position:'Posición','Front Weight':'Peso delantero','Rear Weight':'Peso trasero',
    'Lever Length':'Longitud de la manija',Options:'Opciones','Chain Pitch':'Paso de cadena',
    Extension:'Extensión','Seat Rise':'Elevación del asiento','Forward Offset':'Desplazamiento hacia delante',
    'Height Adjustment':'Ajuste de altura'
  };
  const translateValue=value=>String(value)
    .replace(/aluminum alloy/gi,'aleación de aluminio').replace(/stainless steel/gi,'acero inoxidable')
    .replace(/Black/g,'Negro').replace(/Blue/g,'Azul').replace(/Red/g,'Rojo')
    .replace(/Gold/g,'Dorado').replace(/Purple/g,'Morado').replace(/Green/g,'Verde')
    .replace(/Silver/g,'Plata').replace(/Orange/g,'Naranja').replace(/White/g,'Blanco')
    .replace(/Direct fit/gi,'Montaje directo').replace(/Floating rotor/gi,'Rotor flotante')
    .replace(/Folding tip/gi,'Punta abatible').replace(/Reach adjuster/gi,'Ajuste de alcance')
    .replace(/N\/A/g,'No aplica');

  records.forEach(([id,name,slug,primary,variants,shortDescription,description,benefits,detailCount=4])=>{
    const product=byId(id);
    if(!product)return;
    const colors=variants.Color||[];
    const defaultSelections=Object.fromEntries(
      Object.entries(variants).map(([label,options])=>[label,options[0]])
    );
    const variantImages=colors.length?{Color:colorImages(slug,colors)}:{};
    const extra={};
    if(id===45){
      extra.gallery=['delantero.webp','detalle-01.webp','detalle-02.webp','detalle-03.webp','detalle-04.webp',
        'trasero.webp','detalle-trasero-01.webp','detalle-trasero-02.webp'].map(file=>media(slug,file));
      extra.variantImages={Posición:{Delantero:media(slug,'delantero.webp'),Trasero:media(slug,'trasero.webp')}};
    }
    if(id===47){
      const optionsByValue={
        '52T':['Negro','Azul','Dorado','Verde','Morado','Rojo','Titanio'],
        '54T':['Negro','Azul','Dorado','Verde','Morado','Rojo','Titanio','Naranja'],
        '58T':['Negro','Azul','Dorado','Verde','Morado','Rojo','Titanio']
      };
      extra.variantDependencies={Color:{dependsOn:'Dientes',optionsByValue}};
      extra.variantImages={};
      extra.variantCombinationLabels=['Dientes','Color'];
      extra.variantCombinationImages={};
      Object.entries(optionsByValue).forEach(([teeth,available])=>available.forEach(color=>{
        extra.variantCombinationImages[`Dientes=${teeth}|Color=${color}`]=media(
          slug,`${teeth.toLowerCase()}-${fileName(color)}.webp`
        );
      }));
    }
    Object.assign(product,{
      name,image:media(slug,primary),gallery:gallery(slug,primary,detailCount),
      variants,defaultSelections,variantImages,shortDescription,description,benefits,
      specifications:Object.fromEntries([
        ...Object.entries(product.specifications||{}).map(([key,value])=>[
          specLabels[key]||key,translateValue(value)
        ]),
        ['Compatibilidad',compatibility[id]]
      ]),
      ...extra
    });
  });
})();


(() => {
  'use strict';

  const productMedia = {
    4: {
      images: {
        Color: {
          Morado: window.ELEVENINE_THEME_ASSET("asset:589f6967d741"),
          Negro: window.ELEVENINE_THEME_ASSET("asset:4a93c8c7ef71"),
          Azul: window.ELEVENINE_THEME_ASSET("asset:8d673d93b788"),
          Rosa: window.ELEVENINE_THEME_ASSET("asset:e7610608f253")
        }
      }
    },
    2: {
      default: window.ELEVENINE_THEME_ASSET("asset:655f5e3874ae"),
      variants: {
        Color: {
          Amarillo: window.ELEVENINE_THEME_ASSET("asset:655f5e3874ae"),
          Rosa: window.ELEVENINE_THEME_ASSET("asset:aaac4be65147")
        }
      }
    },
    3: {
      default: window.ELEVENINE_THEME_ASSET("asset:1eb909aba670"),
      variants: {
        'Edición': {
          BMW: window.ELEVENINE_THEME_ASSET("asset:1eb909aba670"),
          HONDA: window.ELEVENINE_THEME_ASSET("asset:8e9ddd646f3f"),
          KTM: window.ELEVENINE_THEME_ASSET("asset:5dabefafefaf"),
          Rockstar: window.ELEVENINE_THEME_ASSET("asset:37833cc0679a"),
          SHERCO: window.ELEVENINE_THEME_ASSET("asset:1ee18b7b219e"),
          YAMAHA: window.ELEVENINE_THEME_ASSET("asset:0d4d8291f7b6")
        }
      }
    },
    6: {
      default: window.ELEVENINE_THEME_ASSET("asset:3c9f215f9017"),
      variants: {
        Color: {
          Gris: window.ELEVENINE_THEME_ASSET("asset:3c9f215f9017"),
          Azul: window.ELEVENINE_THEME_ASSET("asset:c38d16307abb")
        }
      }
    },
    7: { default: window.ELEVENINE_THEME_ASSET("asset:7837e5e56cb3") },
    8: { default: window.ELEVENINE_THEME_ASSET("asset:9b22edac4261") },
    9: { default: window.ELEVENINE_THEME_ASSET("asset:305777185746") },
    11: {
      default: window.ELEVENINE_THEME_ASSET("asset:75afbdef651d"),
      galleryVideos: [
        {
          src: window.ELEVENINE_THEME_ASSET("asset:04fa91950eb6"),
          label: 'Conjunto de carpas KTM · vista de pista'
        }
      ]
    },
    12: {
      default: window.ELEVENINE_THEME_ASSET("asset:6d79b9988a7c"),
      variants: {
        Color: {
          'Blanco/Rojo': window.ELEVENINE_THEME_ASSET("asset:6d79b9988a7c")
        }
      }
    },
    13: {
      default: window.ELEVENINE_THEME_ASSET("asset:2312b312a803"),
      variants: {
        Color: {
          Gris: window.ELEVENINE_THEME_ASSET("asset:2312b312a803"),
          Negro: window.ELEVENINE_THEME_ASSET("asset:dac5d269ac7a"),
          Rojo: window.ELEVENINE_THEME_ASSET("asset:fc9f3f70e26f")
        }
      }
    },
    15: {
      default: window.ELEVENINE_THEME_ASSET("asset:9bdb9867f9e8"),
      variants: {
        Color: {
          Negro: window.ELEVENINE_THEME_ASSET("asset:9bdb9867f9e8"),
          'Blanco/Rojo': window.ELEVENINE_THEME_ASSET("asset:4b33453229cc"),
          'Blanco/Naranja': window.ELEVENINE_THEME_ASSET("asset:4b33453229cc")
        }
      }
    },
    16: {
      default: window.ELEVENINE_THEME_ASSET("asset:68cb120cb004"),
      variants: {
        Color: {
          Blanco: window.ELEVENINE_THEME_ASSET("asset:68cb120cb004"),
          'Negro Brillante': window.ELEVENINE_THEME_ASSET("asset:5d66b2af1cdc"),
          Negro: window.ELEVENINE_THEME_ASSET("asset:f61e3a53c0c9"),
          Azul: window.ELEVENINE_THEME_ASSET("asset:4bc2a891e2f8")
        }
      }
    },
    19: {
      default: window.ELEVENINE_THEME_ASSET("asset:7294d1e1e794"),
      variants: {
        'Versión': {
          Negro: window.ELEVENINE_THEME_ASSET("asset:7294d1e1e794"),
          'NEGRO PERSONALIZADO': window.ELEVENINE_THEME_ASSET("asset:5c55746af400")
        }
      }
    },
    20: {
      default: window.ELEVENINE_THEME_ASSET("asset:085baf34d756"),
      variants: {
        'Versión': {
          Blanco: window.ELEVENINE_THEME_ASSET("asset:085baf34d756"),
          Negro: window.ELEVENINE_THEME_ASSET("asset:bbf64839b69b"),
          Rojo: window.ELEVENINE_THEME_ASSET("asset:ca3bd0578be3"),
          'BLANCO PERSONALIZADO': window.ELEVENINE_THEME_ASSET("asset:232ad3673f52"),
          'NEGRO PERSONALIZADO': window.ELEVENINE_THEME_ASSET("asset:1d4f486d58ee"),
          'ROJO PERSONALIZADO': window.ELEVENINE_THEME_ASSET("asset:ab8f4ff8330a")
        }
      }
    },
    21: { default: window.ELEVENINE_THEME_ASSET("asset:4647a8443cad") },
    22: {
      default: window.ELEVENINE_THEME_ASSET("asset:ed496aef5577"),
      variants: {
        Color: {
          Amarillo: window.ELEVENINE_THEME_ASSET("asset:ef198b768a7b"),
          Verde: window.ELEVENINE_THEME_ASSET("asset:a72562c08884"),
          Azul: window.ELEVENINE_THEME_ASSET("asset:ed496aef5577"),
          Rosa: window.ELEVENINE_THEME_ASSET("asset:c3543e034bb4")
        }
      },
      modelVariants: {
        '2025': {
          Color: {
            Amarillo: window.ELEVENINE_THEME_ASSET("asset:ef198b768a7b"),
            Verde: window.ELEVENINE_THEME_ASSET("asset:a72562c08884"),
            Azul: window.ELEVENINE_THEME_ASSET("asset:ed496aef5577"),
            Rosa: window.ELEVENINE_THEME_ASSET("asset:c3543e034bb4")
          }
        },
        '2026': {
          Color: {
            Verde: window.ELEVENINE_THEME_ASSET("asset:a72562c08884"),
            Azul: window.ELEVENINE_THEME_ASSET("asset:ed496aef5577"),
            Amarillo: window.ELEVENINE_THEME_ASSET("asset:ef198b768a7b")
          }
        }
      },
      modelDefaults: {
        '2025': window.ELEVENINE_THEME_ASSET("asset:c3543e034bb4"),
        '2026': window.ELEVENINE_THEME_ASSET("asset:ed496aef5577")
      }
    },
    24: {
      default: window.ELEVENINE_THEME_ASSET("asset:0cc134fa73b5"),
      variants: {
        Color: {
          Blanco: window.ELEVENINE_THEME_ASSET("asset:0cc134fa73b5"),
          Negro: window.ELEVENINE_THEME_ASSET("asset:37c6eb331a65"),
          Azul: window.ELEVENINE_THEME_ASSET("asset:de3e001ba06c")
        }
      }
    },
    25: { default: window.ELEVENINE_THEME_ASSET("asset:ea344e6a3972") },
    26: {
      default: window.ELEVENINE_THEME_ASSET("asset:facab8256e04"),
      variants: {
        'Diseño': {
          KTM: window.ELEVENINE_THEME_ASSET("asset:facab8256e04"),
          ELN9: window.ELEVENINE_THEME_ASSET("asset:af3dddd82b42"),
          TLD: window.ELEVENINE_THEME_ASSET("asset:4c81e72fc850")
        }
      }
    },
    27: {
      default: window.ELEVENINE_THEME_ASSET("asset:a371fd914084"),
      variants: {
        Color: {
          Blanco: window.ELEVENINE_THEME_ASSET("asset:a371fd914084"),
          Gris: window.ELEVENINE_THEME_ASSET("asset:ee909696c3b7"),
          Rojo: window.ELEVENINE_THEME_ASSET("asset:e9c81a131df7")
        }
      }
    },
    28: {
      default: window.ELEVENINE_THEME_ASSET("asset:8e3cedf5c088"),
      variants: {
        Color: {
          Blanco: window.ELEVENINE_THEME_ASSET("asset:f6becf0dfdf7"),
          Gris: window.ELEVENINE_THEME_ASSET("asset:8e3cedf5c088"),
          Rojo: window.ELEVENINE_THEME_ASSET("asset:669142a8ad92")
        }
      }
    },
    29: {
      default: window.ELEVENINE_THEME_ASSET("asset:90d1930a7a82"),
      variants: {
        Color: {
          Blanco: window.ELEVENINE_THEME_ASSET("asset:a0cbb7132ccf"),
          Gris: window.ELEVENINE_THEME_ASSET("asset:acd1e06ad53e"),
          Rojo: window.ELEVENINE_THEME_ASSET("asset:90d1930a7a82")
        }
      }
    },
    30: {
      default: window.ELEVENINE_THEME_ASSET("asset:23936fcb2ffe"),
      variants: {
        'Edición': {
          BMW: window.ELEVENINE_THEME_ASSET("asset:23936fcb2ffe"),
          HONDA: window.ELEVENINE_THEME_ASSET("asset:3cf3c88f7574"),
          KTM: window.ELEVENINE_THEME_ASSET("asset:e1f31f743f50"),
          Rockstar: window.ELEVENINE_THEME_ASSET("asset:4f3141da28b3"),
          SHERCO: window.ELEVENINE_THEME_ASSET("asset:f106089a09ba"),
          YAMAHA: window.ELEVENINE_THEME_ASSET("asset:31e9b61635ff")
        }
      }
    },
    31: {
      default: window.ELEVENINE_THEME_ASSET("asset:d6787f47ca72"),
      variants: {
        Color: {
          Azul: window.ELEVENINE_THEME_ASSET("asset:d6787f47ca72"),
          Negro: window.ELEVENINE_THEME_ASSET("asset:a1477a581a36"),
          Rojo: window.ELEVENINE_THEME_ASSET("asset:d3c2e38c0799"),
          Rosa: window.ELEVENINE_THEME_ASSET("asset:1e3fbe3a2b27")
        }
      }
    },
    32: {
      default: window.ELEVENINE_THEME_ASSET("asset:50dbc6e571c0"),
      variants: {
        Color: {
          Morado: window.ELEVENINE_THEME_ASSET("asset:8eeeae526130"),
          Verde: window.ELEVENINE_THEME_ASSET("asset:2672980aa77f"),
          Negro: window.ELEVENINE_THEME_ASSET("asset:50dbc6e571c0"),
          Azul: window.ELEVENINE_THEME_ASSET("asset:f663f0e22ad9"),
          Blanco: window.ELEVENINE_THEME_ASSET("asset:b61ab74c8cc4")
        }
      }
    },
    33: {
      default: window.ELEVENINE_THEME_ASSET("asset:e9b45b6dea7c"),
      variants: {
        Color: {
          'Café': window.ELEVENINE_THEME_ASSET("asset:e9b45b6dea7c"),
          Negro: window.ELEVENINE_THEME_ASSET("asset:5728cd662893")
        }
      }
    },
    34: {
      default: window.ELEVENINE_THEME_ASSET("asset:b30fb318fd9f"),
      variants: {
        Color: {
          Negro: window.ELEVENINE_THEME_ASSET("asset:f030b1edf835"),
          Verde: window.ELEVENINE_THEME_ASSET("asset:ddafb8c4467b"),
          Blanco: window.ELEVENINE_THEME_ASSET("asset:b30fb318fd9f"),
          'Café': window.ELEVENINE_THEME_ASSET("asset:63a87851009a")
        }
      }
    }
  };

  const videos = {
    1: window.ELEVENINE_THEME_ASSET("asset:b23621c08d17"),
    5: window.ELEVENINE_THEME_ASSET("asset:56930e3e5f06"),
    10: window.ELEVENINE_THEME_ASSET("asset:82767e516d2d"),
    14: window.ELEVENINE_THEME_ASSET("asset:a08629666d1c"),
    17: window.ELEVENINE_THEME_ASSET("asset:22966fe6c960"),
    18: window.ELEVENINE_THEME_ASSET("asset:019092e0fa59")
  };

  Object.entries(productMedia).forEach(([id, media]) => {
    videos[id] = media.default;
  });

  window.ELEVENINE_PRODUCT_MEDIA = productMedia;
  window.ELEVENINE_PRODUCT_VIDEOS = videos;

  if (Array.isArray(window.ELEVENINE_PRODUCTS)) {
    window.ELEVENINE_PRODUCTS.forEach(product => {
      const media = productMedia[product.id];
      if (videos[product.id]) product.video = videos[product.id];
      if (media?.variants) product.variantVideos = media.variants;
      if (media?.modelVariants) product.modelVariantVideos = media.modelVariants;
      if (media?.modelDefaults) product.modelDefaultVideos = media.modelDefaults;
      if (media?.images) product.variantImages = media.images;
      if (media?.galleryVideos) product.galleryVideos = media.galleryVideos;
    });
  }
})();
